var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _g, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _g2, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _g3, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _g4, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPba(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1512,
    height: 737,
    viewBox: "0 0 1512 737",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1512 0.0209961H0V736.956H1512V0.0209961Z",
    fill: "url(#paint0_linear_1842_785)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1330.93 259.821L1380.53 231.421L1476.43 285.121L1381.83 338.921L1473.33 390.121L1427.53 418.321L1285.83 338.321L1381.23 284.721L1330.93 259.821Z",
    fill: "#C7D2F1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1456.34 689.056L1361.66 635.856L1267.5 688.456L1315.15 715.556L1364.79 688.456L1412.23 715.556L1456.34 689.056Z",
    fill: "#CCCFF0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M597.084 395.021L646.302 366.721L741.402 420.021L647.658 473.521L738.273 524.321L692.809 552.321L552.245 472.921L646.823 419.721L597.084 395.021Z",
    fill: "#CCCFF0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M956.707 598.764L860.46 651.464L764.213 598.764L718.332 624.164L860.46 703.564L1003.21 625.164L956.707 598.764Z",
    fill: "#CCCFF0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1282.39 85.5216L1373 138.622L1328.9 164.022L1379.16 191.922L1470.09 138.622L1328.9 60.1216L1282.39 85.5216Z",
    fill: "#C7D2F1"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1198.6 109.421L1104.02 56.2207L1009.75 108.821L1057.51 135.921L1107.04 108.821L1154.59 135.921L1198.6 109.421Z",
    fill: "#CCCFF0"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M745.258 172.743L846.218 231.828L797.074 260.091L853.073 291.247L954.382 231.828L797.074 144.48L745.258 172.743Z",
    fill: "#CCCFF0"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1842_785)"
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M1075.99 306.179C1075.71 306.179 1075.57 306.179 1075.29 306.038L1015.65 271.536C1015.09 271.114 1014.81 270.41 1015.23 269.705C1015.65 269.142 1016.35 268.861 1017.06 269.283L1076.69 303.785C1077.26 304.207 1077.54 304.912 1077.12 305.616C1076.83 306.038 1076.41 306.179 1075.99 306.179Z",
    fill: "url(#paint1_linear_1842_785)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M966.841 384.619C966.56 384.619 966.419 384.619 966.138 384.478L863.037 324.346C862.615 324.064 862.334 323.642 862.334 323.078C862.334 322.515 862.615 322.093 863.037 321.811L957.558 270.41C958.261 269.987 959.105 270.269 959.527 270.973C959.949 271.677 959.668 272.522 958.965 272.945L866.554 323.219L967.545 382.084C968.248 382.506 968.389 383.351 968.107 384.055C967.826 384.337 967.404 384.619 966.841 384.619Z",
    fill: "url(#paint2_linear_1842_785)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M1092.87 205.489L1204.69 270.128C1207.79 271.959 1210.18 269.987 1210.18 265.903V203.236C1210.18 199.152 1207.64 194.364 1204.69 192.674L1092.87 128.036C1089.77 126.205 1087.38 128.177 1087.38 132.261V194.928C1087.38 199.012 1089.77 203.659 1092.87 205.489Z",
    fill: "url(#paint3_linear_1842_785)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M1192.59 454.327L1028.17 359.27C1026.9 358.566 1026.2 357.299 1026.2 355.89C1026.2 354.482 1026.9 353.215 1028.17 352.511L1130.28 293.505L1131.13 293.083L1303.43 392.646C1304.7 393.35 1305.4 394.617 1305.4 396.025C1305.4 397.434 1304.7 398.701 1303.43 399.405L1208.21 454.468C1205.82 455.876 1203.14 456.58 1200.47 456.58C1197.66 456.439 1194.99 455.735 1192.59 454.327ZM1029.71 355.468C1029.43 355.609 1029.43 355.89 1029.43 356.031C1029.43 356.172 1029.43 356.454 1029.71 356.594L1194.14 451.651C1197.94 453.904 1202.72 453.904 1206.52 451.651L1301.74 396.589C1302.02 396.448 1302.02 396.166 1302.02 396.025C1302.02 395.884 1302.02 395.603 1301.74 395.462L1131.13 296.885L1029.71 355.468Z",
    fill: "url(#paint4_linear_1842_785)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M1130.99 253.933L1153.91 117.897L1152.08 117.052L1154.9 115.503C1155.46 115.08 1156.16 115.221 1157.01 115.643L1340.14 221.403C1341.69 222.248 1342.81 224.501 1342.53 226.05L1319.47 363.213C1319.32 363.917 1319.04 364.34 1318.48 364.621L1315.81 366.17L1315.39 363.636H1315.53L1133.52 258.44C1131.83 257.736 1130.71 255.482 1130.99 253.933Z",
    fill: "url(#paint5_linear_1842_785)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M1339.02 225.205L1341.97 223.938C1342.25 224.642 1342.53 225.487 1342.39 226.191L1319.33 363.354C1319.18 364.058 1318.9 364.48 1318.34 364.762L1315.67 366.311L1315.25 363.776H1315.39L1306.24 358.425L1339.02 225.205Z",
    fill: "url(#paint6_linear_1842_785)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M1130.42 260.13L1313.56 365.889C1314.96 366.734 1316.23 366.171 1316.37 364.762L1339.44 227.599C1339.72 226.05 1338.59 223.797 1337.05 222.952L1154.05 117.334C1152.65 116.489 1151.38 117.052 1151.24 118.46L1128.17 255.623C1127.75 257.032 1128.88 259.285 1130.42 260.13Z",
    fill: "#44106F"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.51
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1156.45 126.064L1332.83 228.021L1311.03 357.158L1134.64 255.201L1156.45 126.064Z",
    fill: "#8151A8"
  }))), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M1015.37 325.191L1025.35 330.401L1125.5 272.522C1127.19 271.537 1130.14 271.678 1131.97 272.804L1304.7 372.649C1306.38 371.663 1313.84 368.142 1313.84 368.142L1310.18 377.718C1310.04 378.141 1309.76 378.563 1309.2 378.845L1203.71 439.822C1202.02 440.808 1199.06 440.667 1197.24 439.541L1020.43 337.302C1019.59 336.879 1019.16 336.316 1018.88 335.753L1015.37 325.191Z",
    fill: "url(#paint7_linear_1842_785)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M1016.91 326.74L1198.08 431.513C1200.05 432.64 1203 432.781 1204.83 431.795L1313 369.269C1314.68 368.283 1314.54 366.593 1312.57 365.326L1131.41 260.552C1129.44 259.426 1126.49 259.285 1124.66 260.271L1016.49 322.797C1014.66 323.923 1014.95 325.613 1016.91 326.74Z",
    fill: "url(#paint8_linear_1842_785)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M1016.92 325.754L1198.08 430.528C1200.05 431.654 1203 431.795 1204.83 430.809L1313 368.283C1313.56 368.002 1313.84 367.579 1313.98 367.157C1314.26 368.002 1313.98 368.846 1313 369.41L1204.83 431.936C1203.14 432.922 1200.05 432.781 1198.08 431.654L1016.92 326.881C1015.65 326.177 1015.09 325.05 1015.37 324.205C1015.51 324.628 1016.07 325.191 1016.92 325.754Z",
    fill: "#FFFAFA"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M1252.79 408.841V406.869C1252.79 406.728 1252.65 406.587 1252.51 406.728L1245.48 410.812C1245.34 410.953 1245.2 411.094 1245.2 411.235V413.206C1245.2 413.347 1245.34 413.488 1245.48 413.347L1252.51 409.263C1252.65 409.263 1252.79 409.122 1252.79 408.841Z",
    fill: "#6A26A3"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M1242.25 414.896V412.924C1242.25 412.783 1242.11 412.643 1241.96 412.783L1234.93 416.867C1234.79 417.008 1234.65 417.149 1234.65 417.29V419.261C1234.65 419.402 1234.79 419.543 1234.93 419.402L1241.96 415.318C1242.25 415.318 1242.25 415.177 1242.25 414.896Z",
    fill: "#6A26A3"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M1284.72 363.495L1134.08 276.465C1133.1 275.902 1131.83 275.902 1130.85 276.465L1077.26 307.588C1076.55 308.01 1076.55 309.137 1077.26 309.559L1227.76 396.589C1228.74 397.152 1230.01 397.152 1230.99 396.589L1284.72 365.607C1285.57 365.044 1285.57 363.918 1284.72 363.495Z",
    fill: "#BB88E4"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M1284.72 365.466L1284.16 365.748L1134.08 279C1133.1 278.437 1131.83 278.437 1130.85 279L1077.82 309.7L1077.26 309.418C1076.55 308.996 1076.55 307.869 1077.26 307.447L1130.85 276.324C1131.83 275.761 1133.1 275.761 1134.08 276.324L1284.72 363.354C1285.57 363.917 1285.57 365.044 1284.72 365.466Z",
    fill: "#481B6C"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M1126.91 284.211L1257.72 359.834L1263.49 356.454L1132.68 280.831L1126.91 284.211Z",
    fill: "#44106F"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M1112.56 292.519L1235.35 363.495L1241.12 360.115L1118.47 289.14L1112.56 292.519Z",
    fill: "#44106F"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M1103.28 297.871L1247.73 381.38L1253.64 378L1109.18 294.491L1103.28 297.871Z",
    fill: "#44106F"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M1093.99 303.222L1238.45 386.731L1244.36 383.351L1099.9 299.842L1093.99 303.222Z",
    fill: "#44106F"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M1084.71 308.574L1229.16 392.083L1235.07 388.703L1090.62 305.194L1084.71 308.574Z",
    fill: "#44106F"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M1265.59 364.481L1271.36 367.861L1277.27 364.481L1271.36 361.101L1265.59 364.481Z",
    fill: "#44106F"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M1245.06 369.128L1257.16 376.029L1262.92 372.649L1250.97 365.749L1245.06 369.128Z",
    fill: "#44106F"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M1128.31 384.478L1087.67 360.96C1086.12 359.974 1086.12 358.566 1087.67 357.58L1115.37 341.526C1116.92 340.541 1119.59 340.541 1121.14 341.526L1161.79 365.044C1163.34 366.03 1163.34 367.438 1161.79 368.424L1134.08 384.478C1132.53 385.464 1130 385.464 1128.31 384.478Z",
    fill: "url(#paint9_linear_1842_785)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M1161.93 366.452L1121.28 342.935C1119.73 341.949 1117.06 341.949 1115.51 342.935L1087.81 358.989C1087.38 359.27 1086.96 359.552 1086.82 359.974C1086.4 359.13 1086.68 358.285 1087.81 357.58L1115.51 341.526C1117.06 340.541 1119.73 340.541 1121.28 341.526L1161.93 365.044C1163.06 365.748 1163.34 366.593 1162.92 367.438C1162.63 367.157 1162.35 366.734 1161.93 366.452Z",
    fill: "#481B6C"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.11
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1842_785",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1134,
    y: 126,
    width: 199,
    height: 232
  }, _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M1156.45 126.064L1332.83 228.021L1311.03 357.158L1134.64 255.201L1156.45 126.064Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1842_785)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1131.13 260.411L1312.29 365.184C1314.26 366.311 1317.21 366.452 1319.04 365.466L1427.21 302.94C1428.9 301.954 1428.76 300.264 1426.79 298.997L1245.48 194.364C1243.51 193.238 1240.56 193.097 1238.73 194.083L1130.56 256.609C1128.88 257.594 1129.16 259.284 1131.13 260.411Z",
    fill: "url(#paint10_linear_1842_785)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1312.85 279.282L1272.21 255.764C1270.66 254.778 1270.66 253.37 1272.21 252.384L1300.06 236.33C1301.6 235.344 1304.27 235.344 1305.82 236.33L1346.47 259.848C1348.02 260.834 1348.02 262.242 1346.47 263.228L1318.76 279.282C1316.93 280.127 1314.4 280.127 1312.85 279.282Z",
    fill: "url(#paint11_linear_1842_785)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1346.33 261.256L1305.82 237.738C1304.27 236.753 1301.6 236.753 1300.05 237.738L1272.35 253.792C1271.92 254.074 1271.5 254.356 1271.36 254.778C1270.94 253.933 1271.22 253.088 1272.35 252.384L1300.05 236.33C1301.6 235.344 1304.27 235.344 1305.82 236.33L1346.47 259.848C1347.6 260.552 1347.88 261.397 1347.46 262.242C1347.17 261.819 1346.89 261.538 1346.33 261.256Z",
    fill: "#481B6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1364.19 315.896L1213.55 228.866C1212.57 228.303 1211.3 228.303 1210.32 228.866L1156.73 259.989C1156.02 260.411 1156.02 261.538 1156.73 261.96L1307.23 348.99C1308.21 349.553 1309.48 349.553 1310.46 348.99L1364.19 318.008C1365.04 317.445 1365.04 316.318 1364.19 315.896Z",
    fill: "#BB88E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1364.19 317.867L1363.63 318.149L1213.55 231.542C1212.57 230.979 1211.3 230.979 1210.32 231.542L1157.29 262.242L1156.73 261.96C1156.02 261.538 1156.02 260.411 1156.73 259.989L1210.32 228.866C1211.3 228.303 1212.57 228.303 1213.55 228.866L1364.19 315.896C1365.04 316.318 1365.04 317.445 1364.19 317.867Z",
    fill: "#481B6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1170.79 257.876L1302.02 333.64L1296.82 336.597L1165.59 260.833L1170.79 257.876Z",
    fill: "#44106F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1184.58 249.849L1309.34 321.951L1304.13 324.909L1179.37 252.806L1184.58 249.849Z",
    fill: "#44106F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1318.62 327.303L1330.3 334.062L1325.09 337.02L1313.42 330.26L1318.62 327.303Z",
    fill: "#44106F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1308.35 337.301L1316.37 341.948L1311.17 345.047L1303.15 340.259L1308.35 337.301Z",
    fill: "#44106F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1193.3 244.779L1338.88 328.992L1333.67 331.95L1188.09 247.877L1193.3 244.779Z",
    fill: "#44106F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1201.88 239.851L1347.6 324.064L1342.39 327.021L1196.67 242.808L1201.88 239.851Z",
    fill: "#44106F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1210.6 234.781L1356.18 318.994L1351.11 321.951L1205.39 237.738L1210.6 234.781Z",
    fill: "#44106F"
  })))), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M1316.65 235.626L1320.03 237.879L1320.45 235.345L1317.07 233.091L1316.65 235.626Z",
    fill: "#CA89FF"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M1313.7 253.229L1317.22 255.341L1319.75 240.273L1316.23 238.02L1313.7 253.229Z",
    fill: "#CA89FF"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M1312.43 261.538L1315.81 263.791L1316.79 257.736L1313.28 255.482L1312.43 261.538Z",
    fill: "#CA89FF"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M1310.89 270.269L1314.4 272.381L1315.39 266.467L1311.87 264.213L1310.89 270.269Z",
    fill: "#CA89FF"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M1310.04 240.696L1313.56 242.949L1314.54 236.893L1311.03 234.64L1310.04 240.696Z",
    fill: "#CA89FF"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M1308.21 252.244L1311.59 254.497L1313.14 245.625L1309.62 243.372L1308.21 252.244Z",
    fill: "#CA89FF"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M1306.38 262.805L1309.9 265.058L1311.17 257.454L1307.65 255.201L1306.38 262.805Z",
    fill: "#CA89FF"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M1309.48 278.859L1313 281.112L1313.98 275.057L1310.46 272.804L1309.48 278.859Z",
    fill: "#CA89FF"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M1311.45 232.387L1314.82 234.64L1315.25 231.965L1311.87 229.711L1311.45 232.387Z",
    fill: "#CA89FF"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M1305.54 285.619L1311.59 289.562L1312.01 287.027L1305.96 283.084L1305.54 285.619Z",
    fill: "#CA89FF"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M1090.76 479.253L949.259 397.434C948.134 396.729 947.571 395.744 947.571 394.758C947.571 393.49 948.415 392.364 949.822 391.519L979.078 374.479C981.329 373.212 984.564 373.071 986.533 374.197L1128.17 456.017C1129.3 456.721 1129.86 457.707 1129.86 458.692C1129.86 459.96 1129.02 461.086 1127.61 461.931L1098.21 478.971C1096.95 479.675 1095.54 479.957 1093.99 479.957C1092.87 479.957 1091.74 479.816 1090.76 479.253ZM980.485 376.873L951.088 393.913C950.384 394.335 950.244 394.617 950.244 394.758C950.244 394.758 950.384 394.899 950.666 395.04L1092.17 476.859C1093.29 477.563 1095.54 477.422 1096.95 476.577L1126.35 459.537C1127.05 459.115 1127.19 458.833 1127.19 458.692C1127.19 458.692 1127.05 458.551 1126.77 458.411L985.267 376.592C984.704 376.31 984.001 376.169 983.298 376.169C982.313 376.169 981.329 376.451 980.485 376.873Z",
    fill: "url(#paint12_linear_1842_785)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M1006.79 327.162C1010.44 329.275 1013.96 332.373 1017.2 335.893C1021.56 321.952 1034.78 317.586 1050.53 326.599C1063.47 334.063 1074.86 348.849 1080.77 364.481C1082.74 364.481 1084.99 365.185 1087.24 366.593C1095.68 371.522 1102.57 383.351 1102.57 393.209C1102.57 393.35 1102.57 393.631 1102.57 393.772C1104.97 393.913 1107.64 394.758 1110.45 396.448C1121.28 402.644 1130 417.994 1130 430.387C1130 442.92 1121.28 447.99 1110.45 441.653L1006.79 381.802C993.706 374.198 983.157 355.89 983.157 340.681C983.157 325.754 993.706 319.558 1006.79 327.162Z",
    fill: "url(#paint13_linear_1842_785)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M1006.79 327.162C1008.9 328.43 1011.01 329.979 1012.98 331.669L1024.51 324.909C1030.84 320.403 1040.12 320.684 1050.39 326.599C1063.33 334.063 1074.72 348.849 1080.63 364.481C1082.6 364.481 1084.85 365.185 1087.1 366.593C1095.54 371.522 1102.43 383.351 1102.43 393.209C1102.43 393.35 1102.43 393.631 1102.43 393.772C1104.82 393.913 1107.5 394.758 1110.31 396.448C1121.14 402.644 1129.86 417.994 1129.86 430.387C1129.86 436.583 1127.75 440.949 1124.24 443.061H1124.09L1095.68 459.537L1089.49 429.683L1006.51 381.802C993.425 374.198 982.876 355.89 982.876 340.681C983.157 325.754 993.706 319.558 1006.79 327.162Z",
    fill: "url(#paint14_radial_1842_785)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M961.215 342.371L990.049 325.613C994.41 323.078 1000.32 323.36 1006.93 327.162C1009.04 328.43 1011.15 329.979 1013.12 331.669L1024.65 324.909C1030.98 320.403 1040.26 320.684 1050.53 326.599C1063.47 334.063 1074.86 348.849 1080.77 364.481C1082.74 364.481 1084.99 365.185 1087.24 366.593C1095.68 371.522 1102.57 383.351 1102.57 393.209C1102.57 393.35 1102.57 393.631 1102.57 393.772C1104.97 393.913 1107.64 394.758 1110.45 396.448C1121.28 402.644 1130 417.994 1130 430.387C1130 436.583 1127.89 440.949 1124.38 443.061H1124.24L1095.82 459.537L1089.63 429.683L1006.65 381.802C996.098 375.606 987.096 362.368 984.001 349.553L961.215 342.371Z",
    fill: "url(#paint15_linear_1842_785)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M978.375 343.779C982.032 345.892 985.549 348.99 988.784 352.511C993.144 338.569 1006.37 334.203 1022.12 343.216C1035.06 350.68 1046.45 365.466 1052.36 381.098C1054.33 381.098 1056.58 381.802 1058.83 383.21C1067.27 388.139 1074.16 399.968 1074.16 409.826C1074.16 409.967 1074.16 410.249 1074.16 410.389C1076.55 410.53 1079.23 411.375 1082.04 413.065C1092.87 419.261 1101.59 434.611 1101.59 447.004C1101.59 459.537 1092.87 464.607 1082.04 458.27L978.375 398.279C965.294 390.674 954.745 372.367 954.745 357.158C954.745 341.949 965.294 336.175 978.375 343.779Z",
    fill: "url(#paint16_linear_1842_785)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M987.799 353.074C984.704 349.553 981.188 346.455 977.39 344.343C971.061 340.681 965.153 340.259 960.934 342.512C965.294 339.555 971.483 339.836 978.375 343.779C981.891 345.751 985.267 348.567 988.221 351.947C987.94 352.229 987.94 352.651 987.799 353.074Z",
    fill: "#FFFAFA"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M1100.6 447.567C1100.6 435.034 1091.88 419.825 1081.05 413.629C1078.24 411.939 1075.57 411.094 1073.18 410.953C1073.18 410.812 1073.18 410.53 1073.18 410.39C1073.18 400.532 1066.28 388.703 1057.85 383.774C1055.45 382.366 1053.34 381.802 1051.38 381.661C1045.33 366.03 1034.07 351.243 1021.13 343.78C1011.71 338.287 1002.99 337.724 996.801 341.245C1003.13 337.161 1012.13 337.442 1022.12 343.216C1035.06 350.68 1046.45 365.467 1052.36 381.098C1054.33 381.098 1056.58 381.802 1058.83 383.21C1067.27 388.139 1074.16 399.969 1074.16 409.826C1074.16 409.967 1074.16 410.249 1074.16 410.39C1076.55 410.53 1079.23 411.375 1082.04 413.065C1092.87 419.262 1101.59 434.611 1101.59 447.004C1101.59 453.482 1099.34 457.848 1095.54 459.819C1098.78 457.707 1100.6 453.482 1100.6 447.567Z",
    fill: "#FFFAFA"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M1180.92 512.488L1183.45 510.798L1112.56 468.128L1111.01 470.522L1180.92 512.488Z",
    fill: "url(#paint17_linear_1842_785)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M1283.88 510.093C1283.32 510.093 1282.9 509.812 1282.61 509.389C1282.19 508.685 1282.47 507.84 1283.18 507.418L1343.52 474.605L1256.03 423.627C1255.33 423.204 1255.19 422.359 1255.47 421.655C1255.89 420.951 1256.73 420.81 1257.44 421.092L1347.03 473.338C1347.46 473.62 1347.74 474.042 1347.74 474.605C1347.74 475.169 1347.46 475.591 1347.03 475.873L1284.44 509.812C1284.3 510.093 1284.02 510.093 1283.88 510.093Z",
    fill: "url(#paint18_linear_1842_785)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M1235.21 600.221C1234.93 600.221 1234.79 600.221 1234.51 600.08L1132.25 540.934C1131.83 540.652 1131.55 540.23 1131.55 539.666C1131.55 539.103 1131.83 538.681 1132.25 538.399L1234.51 479.253C1234.93 478.971 1235.49 478.971 1235.92 479.253L1338.17 538.399C1338.6 538.681 1338.88 539.103 1338.88 539.666C1338.88 540.23 1338.6 540.652 1338.17 540.934L1235.92 600.08C1235.78 600.221 1235.49 600.221 1235.21 600.221ZM1135.77 539.807L1235.21 597.264L1334.66 539.807L1235.21 482.351L1135.77 539.807Z",
    fill: "url(#paint19_linear_1842_785)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M1235.21 578.956L1303.15 539.807L1235.21 500.517L1167.28 539.807L1235.21 578.956Z",
    fill: "url(#paint20_linear_1842_785)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M1217.91 517.698C1217.91 517.698 1216.79 518.824 1215.52 520.233C1214.26 521.641 1211.02 523.472 1209.47 524.317C1208.07 525.161 1201.6 529.809 1200.19 534.597C1198.78 539.385 1203.28 540.089 1207.93 539.385C1212.57 538.681 1217.07 534.456 1218.33 532.907C1219.6 531.358 1224.1 527.978 1229.87 525.161C1235.63 522.345 1232.26 518.261 1232.26 518.261L1217.91 517.698Z",
    fill: "#270841"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M1259.97 532.907C1259.97 532.907 1260.81 535.019 1261.09 537.836C1261.23 540.652 1261.52 546.567 1261.66 548.257C1261.8 549.947 1261.66 554.312 1258.56 558.255C1255.33 562.198 1253.78 563.888 1249.7 562.198C1245.62 560.508 1245.9 553.608 1246.75 550.087C1247.59 546.567 1248.43 538.681 1248.43 537.836C1248.43 536.991 1248.72 536.427 1248.72 536.427L1259.97 532.907Z",
    fill: "#270841"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M1205.82 436.442C1205.82 436.442 1205.96 467.846 1212.85 484.745C1212.85 484.745 1217.77 499.531 1217.91 516.993C1217.91 516.993 1216.65 519.951 1218.33 522.486C1220.02 525.02 1230.71 527.414 1232.68 519.528C1234.65 511.501 1234.37 496.433 1232.54 490.096C1230.71 483.759 1233.81 466.578 1233.81 466.578C1233.81 466.578 1236.76 468.55 1240.28 481.083C1243.79 493.616 1246.47 498.405 1247.73 501.925C1249 505.446 1249.7 526.429 1248.58 536.709C1248.58 536.709 1257.3 538.117 1259.83 534.033C1262.5 529.949 1263.77 508.403 1263.34 501.503C1262.92 494.602 1260.53 472.493 1261.09 465.733C1261.66 458.974 1263.2 453.481 1261.8 446.581C1260.39 439.681 1214.96 423.486 1214.96 423.486L1205.82 436.442Z",
    fill: "#44106F"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M1261.09 465.874C1261.66 459.114 1263.2 453.622 1261.8 446.722C1261.23 444.187 1254.48 440.244 1246.33 436.442C1232.26 434.752 1214.54 432.921 1213.27 433.062C1212.15 433.203 1209.19 434.188 1206.8 435.174L1205.82 436.582C1205.82 436.582 1205.82 438.554 1205.96 441.652C1209.19 442.779 1215.52 441.793 1215.52 441.793C1216.37 444.046 1221.57 451.932 1228.32 455.594C1235.07 459.114 1255.05 458.41 1256.17 459.819C1257.3 461.086 1257.02 478.407 1256.87 480.52C1256.73 482.773 1258.42 496.574 1259.97 508.685C1261.52 520.655 1258.42 535.16 1258.28 535.723C1258.98 535.301 1259.55 534.878 1259.97 534.174C1262.64 530.09 1263.91 508.544 1263.49 501.643C1262.92 494.743 1260.53 472.634 1261.09 465.874Z",
    fill: "#270841"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M1223.68 334.062C1223.68 334.062 1213.41 336.175 1210.04 336.879C1209.47 337.02 1209.05 337.442 1208.77 337.865C1207.79 340.4 1205.11 348.004 1206.66 359.552C1208.63 373.634 1207.64 382.929 1207.64 382.929L1202.3 407.291C1202.3 407.291 1195.83 430.527 1196.25 431.231C1196.81 431.936 1209.61 442.216 1213.69 440.948C1217.77 439.681 1216.51 437.287 1216.51 437.287C1216.51 437.287 1219.46 454.327 1234.09 454.467C1248.86 454.608 1260.81 455.031 1263.48 449.116C1266.16 443.201 1263.63 418.135 1261.23 408.136C1258.84 398.138 1253.22 378.281 1253.22 378.281L1275.3 354.904L1257.3 340.399C1257.3 340.399 1253.08 332.091 1251.39 330.964C1249.56 329.838 1248.58 330.683 1248.58 330.683L1223.68 334.062Z",
    fill: "#8151A8"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M1214.26 435.597C1214.26 436.442 1213.69 437.709 1211.02 438.554C1208.21 439.399 1201.32 435.034 1196.67 431.654C1198.92 433.625 1210.04 442.075 1213.83 440.948C1214.68 440.667 1215.24 440.385 1215.66 440.103C1214.96 438.132 1214.4 436.442 1214.26 435.597Z",
    fill: "url(#paint21_linear_1842_785)"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M1263.63 447.144C1260.81 453.341 1248.15 453.059 1232.68 452.777C1228.74 452.777 1225.65 451.51 1223.12 449.82C1225.79 452.496 1229.31 454.467 1234.37 454.467C1249.14 454.608 1261.09 455.031 1263.77 449.116C1264.61 447.144 1264.89 443.201 1264.89 438.272C1264.75 442.356 1264.33 445.455 1263.63 447.144Z",
    fill: "url(#paint22_linear_1842_785)"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M1251.11 330.823C1251.11 330.823 1254.76 335.47 1249.14 341.526C1245.76 345.187 1239.71 353.214 1234.65 361.664C1231.42 366.874 1228.6 369.691 1226.92 374.197C1226.92 374.197 1226.77 368.846 1226.77 360.396C1226.77 352.51 1226.92 344.342 1227.34 342.23C1228.18 338.005 1247.03 328.711 1251.11 330.823Z",
    fill: "#ECD6FF"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M1236.62 344.202C1236.62 344.202 1234.65 345.328 1233.95 345.187C1233.24 345.047 1231.13 342.934 1231.13 342.934C1231.13 342.934 1225.79 342.653 1225.23 340.399C1224.66 338.146 1224.38 335.752 1223.82 334.626C1223.26 333.358 1221.15 327.584 1221.15 325.331C1221.15 323.078 1221.43 318.853 1220.44 316.6C1219.46 314.347 1218.76 292.378 1239.85 293.505C1260.95 294.631 1253.92 316.459 1253.92 316.459C1253.92 316.459 1255.47 317.163 1254.48 319.98C1253.5 322.796 1253.22 323.078 1252.8 324.486C1252.23 325.894 1252.09 326.739 1250.69 327.866L1250.26 330.401C1250.26 330.401 1251.11 334.344 1248.43 338.146C1245.76 342.23 1236.62 344.202 1236.62 344.202Z",
    fill: "#FCD1C5"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M1209.47 337.161C1209.47 337.161 1207.22 337.442 1199.49 355.749C1195.13 365.889 1188.52 376.451 1187.11 384.055C1185.56 391.66 1186.12 399.828 1187.67 400.532C1189.08 401.095 1215.1 411.657 1223.26 414.896C1223.68 415.037 1224.24 414.755 1224.24 414.333L1226.77 401.658L1210.6 394.899C1210.6 394.899 1207.64 390.956 1204.69 389.547C1204.69 389.547 1208.07 383.633 1207.93 381.943C1207.79 380.253 1208.63 363.213 1206.94 356.313C1205.25 349.131 1209.47 337.161 1209.47 337.161Z",
    fill: "#44106F"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M1217.77 386.026C1217.77 386.026 1215.52 384.477 1214.96 384.196C1214.4 383.914 1211.44 382.928 1210.88 382.647C1210.46 382.506 1208.77 382.506 1207.79 382.647C1207.5 382.647 1207.22 382.787 1207.08 383.069C1206.38 384.337 1204.27 387.998 1204.55 389.547C1204.55 389.547 1209.89 393.068 1210.46 394.617L1211.3 394.758C1211.3 394.898 1215.24 387.153 1217.77 386.026Z",
    fill: "#FCD1C5"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M1261.38 408.136C1260.81 405.742 1260.11 402.785 1259.27 399.687L1225.93 413.065C1225.93 413.065 1235.49 425.457 1252.94 425.176C1257.72 425.035 1261.23 423.486 1263.77 422.078C1262.92 416.585 1262.22 411.516 1261.38 408.136Z",
    fill: "#44106F"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M1275.44 355.045C1275.44 355.045 1266.72 356.031 1259.41 367.016C1252.09 378 1246.61 390.815 1246.61 390.815L1246.33 392.223C1245.62 396.025 1241.54 398.138 1238.03 396.448C1230.71 392.927 1219.74 387.576 1217.77 386.027C1217.77 386.027 1211.16 389.547 1209.05 398.138C1207.5 405.038 1207.79 405.038 1207.79 405.038C1207.79 405.038 1236.76 419.543 1248.15 419.684C1259.55 419.825 1274.74 382.929 1276.57 375.183C1278.39 367.438 1280.36 357.299 1275.44 355.045Z",
    fill: "#44106F"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M1275.44 355.045C1275.44 355.045 1266.72 356.031 1259.41 367.016C1252.09 378 1246.61 390.815 1246.61 390.815L1246.33 392.223C1245.62 396.025 1241.54 398.138 1238.03 396.448C1230.71 392.927 1219.74 387.576 1217.77 386.027C1217.77 386.027 1211.16 389.547 1209.05 398.138C1207.5 405.038 1207.79 405.038 1207.79 405.038C1207.79 405.038 1236.76 419.543 1248.15 419.684C1259.55 419.825 1274.74 382.929 1276.57 375.183C1278.39 367.438 1280.36 357.299 1275.44 355.045Z",
    fill: "#541E81"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M1242.25 398.278C1242.25 398.278 1245.9 401.799 1247.59 399.968C1249.28 398.137 1248.72 397.856 1248.72 397.856C1248.72 397.856 1252.09 397.856 1252.51 395.884C1252.94 393.772 1254.62 394.899 1254.76 392.645C1254.91 390.251 1252.09 390.674 1252.09 390.674L1242.25 398.278Z",
    fill: "#8151A8"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M1237.89 396.307C1237.89 396.307 1238.87 395.321 1240.28 394.335C1241.68 393.208 1243.79 388.702 1244.22 388.28C1244.64 387.857 1249.14 384.618 1251.25 384.618C1253.36 384.618 1251.67 387.012 1251.25 387.294C1250.69 387.575 1248.58 388.561 1248.58 388.561C1248.58 388.561 1246.33 390.251 1246.18 390.533C1245.9 390.814 1252.09 390.251 1253.08 390.814C1254.06 391.378 1253.78 393.068 1253.08 393.49C1252.37 393.913 1251.81 393.913 1251.81 393.913C1251.81 393.913 1252.51 395.743 1250.54 396.588C1248.72 397.433 1248.29 396.87 1248.29 396.87C1248.29 396.87 1248.01 400.109 1245.06 399.405L1237.89 396.307Z",
    fill: "#FCD1C5"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M1220.58 305.475C1220.58 305.475 1217.63 314.206 1224.95 311.953C1232.26 309.7 1239.01 305.616 1241.26 307.306C1242.95 308.573 1242.81 312.235 1242.67 313.924C1242.67 314.488 1242.81 315.051 1243.09 315.614L1245.2 318.853C1245.48 319.276 1245.62 319.698 1245.62 320.121L1245.76 322.374C1245.76 322.937 1246.18 323.36 1246.75 323.36H1247.31C1247.87 323.36 1248.29 323.078 1248.43 322.515L1249.14 319.276C1249.14 319.276 1250.97 315.051 1254.48 316.741C1254.48 316.741 1257.01 313.502 1256.31 306.602C1255.75 299.56 1252.8 292.378 1239.15 290.829C1225.23 289.139 1220.58 305.475 1220.58 305.475Z",
    fill: "#341C1C"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M1240.28 352.088L1238.31 350.398C1238.31 350.398 1236.34 351.947 1235.64 353.637C1234.79 355.327 1235.49 360.537 1235.49 360.537L1234.79 361.523L1234.09 360.115L1233.67 353.778C1233.67 353.778 1234.51 349.131 1234.51 348.99C1234.65 348.849 1238.45 349.553 1238.45 349.553C1238.45 349.553 1239.57 350.821 1240.28 352.088Z",
    fill: "#7A30B6"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M1230.57 345.61C1230.57 345.61 1228.32 345.751 1227.34 346.455C1227.34 346.455 1229.59 346.596 1230.01 346.736C1230.43 346.736 1230.57 345.61 1230.57 345.61Z",
    fill: "#7A30B6"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M1234.65 346.173L1238.17 349.694C1238.17 349.694 1234.93 351.102 1233.95 353.918C1233.95 353.918 1230.01 354.623 1229.59 353.073C1229.17 351.524 1229.73 348.004 1229.31 346.314C1229.02 344.765 1234.65 346.173 1234.65 346.173Z",
    fill: "#44106F"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M1229.87 353.074C1229.87 353.074 1229.17 356.031 1228.32 357.298C1227.62 358.566 1226.77 359.833 1226.77 359.833L1226.49 377.436C1226.49 377.436 1233.24 364.34 1234.79 361.664C1234.79 361.664 1234.79 355.186 1234.09 354.059C1233.53 352.792 1229.87 353.074 1229.87 353.074Z",
    fill: "#44106F"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M1247.87 327.584C1243.37 339.695 1231.28 343.075 1231.28 343.075C1231.28 343.075 1233.39 345.188 1234.09 345.328C1234.79 345.469 1236.76 344.343 1236.76 344.343C1236.76 344.343 1245.9 342.371 1248.72 338.569C1251.39 334.767 1250.55 330.823 1250.55 330.823L1250.97 328.289C1248.86 328.57 1247.87 327.584 1247.87 327.584Z",
    fill: "#F3B8AA"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M1257.16 342.089C1257.16 342.089 1255.33 347.863 1255.19 348.004C1254.91 348.286 1250.97 347.722 1250.97 347.722L1252.8 351.384C1252.8 351.384 1232.12 372.507 1227.76 383.914C1227.76 383.914 1237.6 369.409 1254.76 352.37L1252.51 348.708L1256.59 349.553L1257.16 342.089Z",
    fill: "#44106F"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M1224.38 336.175L1223.26 337.301L1224.52 338.569L1220.73 341.808C1220.73 341.808 1219.04 365.326 1223.12 381.098C1223.12 381.098 1217.35 366.593 1219.32 341.104L1223.4 338.428L1222.13 337.161L1224.38 336.175Z",
    fill: "#44106F"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M1233.81 466.719L1228.88 461.227C1231.13 464.748 1228.04 480.098 1227.62 483.618C1227.2 487.139 1230.15 494.602 1230.99 503.193C1231.98 511.783 1229.31 524.035 1229.31 524.035C1230.85 523.19 1231.98 521.782 1232.54 519.528C1234.51 511.501 1234.23 496.433 1232.4 490.096C1230.71 483.9 1233.81 466.719 1233.81 466.719Z",
    fill: "#270841"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M1248.29 419.543C1259.69 419.684 1274.88 382.788 1276.71 375.042C1276.99 373.775 1277.27 372.367 1277.55 371.099C1277.55 371.24 1274.32 379.126 1271.36 386.308C1268.27 393.49 1252.65 414.896 1244.92 416.022C1237.89 417.149 1213.13 404.756 1208.35 402.362C1207.79 405.038 1208.07 405.038 1208.07 405.038C1208.07 405.038 1236.9 419.402 1248.29 419.543Z",
    fill: "url(#paint23_linear_1842_785)"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M1246.89 323.219C1247.45 323.219 1247.87 322.937 1248.01 322.374L1248.72 319.135C1248.72 319.135 1250.54 314.91 1254.06 316.6C1254.06 316.6 1256.45 313.502 1256.03 307.024C1251.81 312.939 1242.81 315.473 1242.81 315.473L1244.92 318.712C1245.2 319.135 1245.34 319.557 1245.34 319.98L1245.48 322.233C1245.48 322.796 1245.9 323.219 1246.47 323.219H1246.89Z",
    fill: "#150A0A"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M1150.12 163.524L1215.8 201.547C1218.9 203.377 1221.29 208.025 1221.29 212.108V274.775C1221.29 278.859 1218.76 280.69 1215.8 279L1138.16 234.218L1150.12 163.524Z",
    fill: "#44106F"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M1089.07 127.754L1092.31 125.501C1093.29 124.797 1094.7 124.656 1096.24 125.642L1208.07 190.281C1211.16 192.111 1213.55 196.759 1213.55 200.842V263.509C1213.55 265.622 1212.85 267.171 1211.72 267.875L1208.35 270.269L1208.21 267.875C1208.07 267.875 1208.07 267.734 1207.93 267.734L1096.1 203.096C1093.01 201.265 1090.62 196.618 1090.62 192.534V129.726C1090.62 129.163 1090.62 128.599 1090.76 128.036L1089.07 127.754Z",
    fill: "url(#paint24_linear_1842_785)"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M1213.27 198.308L1183.73 215.347L1176.28 211.123L1209.75 191.689C1211.44 193.379 1212.71 195.773 1213.27 198.308Z",
    fill: "url(#paint25_linear_1842_785)"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M1092.87 205.489L1204.69 270.128C1207.79 271.959 1210.18 269.987 1210.18 265.903V203.236C1210.18 199.152 1207.64 194.364 1204.69 192.674L1092.87 128.036C1089.77 126.205 1087.38 128.177 1087.38 132.261V194.928C1087.38 199.012 1089.77 203.659 1092.87 205.489Z",
    fill: "url(#paint26_linear_1842_785)"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M1209.61 266.185V203.518C1209.61 199.434 1207.08 194.646 1204.13 192.956L1092.31 128.318C1091.04 127.614 1090.06 127.473 1089.07 127.895C1090.06 127.191 1091.46 127.191 1092.87 128.036L1204.69 192.675C1207.79 194.506 1210.18 199.153 1210.18 203.237V265.904C1210.18 268.438 1209.33 269.988 1207.93 270.551C1208.91 269.847 1209.61 268.298 1209.61 266.185Z",
    fill: "#FFFAFA"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M1103.28 165.918L1194.56 218.586C1195.27 219.009 1195.83 219.15 1196.25 218.586C1196.25 218.446 1196.25 218.305 1196.25 218.164V204.363C1196.25 203.237 1195.55 201.969 1194.84 201.547L1102.86 148.456C1102.72 148.456 1102.72 148.315 1102.57 148.315C1101.87 148.456 1101.87 149.019 1101.87 150.005L1101.59 163.242C1101.59 164.51 1102.43 165.496 1103.28 165.918Z",
    fill: "#A263D6"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M1103 196.055L1194.42 248.723C1195.13 249.145 1195.97 249.568 1196.11 248.723C1196.11 248.582 1196.11 248.441 1196.11 248.3V234.5C1196.11 233.373 1195.41 232.106 1194.7 231.683L1102.86 178.733C1102.72 178.733 1102.72 178.592 1102.57 178.592C1101.87 178.311 1101.73 179.296 1101.73 180.282V193.379C1101.59 194.365 1102.29 195.632 1103 196.055Z",
    fill: "#A263D6"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M1102.57 148.456C1102.57 148.597 1102.57 148.737 1102.57 148.878V162.679C1102.57 163.806 1103.28 165.073 1103.98 165.496L1195.97 218.586C1196.11 218.586 1196.11 218.586 1196.25 218.727C1196.11 219.572 1195.55 219.854 1194.85 219.431L1102.86 166.2C1102.01 165.777 1101.45 164.51 1101.45 163.383V149.582C1101.31 148.597 1101.87 148.174 1102.57 148.456Z",
    fill: "#FFFAFA"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M1102.57 178.592C1102.57 178.733 1102.57 178.874 1102.57 179.015V192.815C1102.57 193.942 1103.28 195.209 1103.98 195.632L1195.97 248.723C1196.11 248.723 1196.11 248.723 1196.25 248.864C1196.11 249.708 1195.55 249.99 1194.85 249.568L1102.86 196.477C1102.01 196.054 1101.45 194.787 1101.45 193.66V179.859C1101.31 178.874 1101.87 178.31 1102.57 178.592Z",
    fill: "#FFFAFA"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M1169.95 198.026L1168.82 200.138L1166.71 197.462L1168.4 195.773L1166.01 193.238L1166.85 191.125L1169.11 193.801L1168.82 190.562L1171.5 192.111L1171.22 194.928L1173.47 194.787L1174.31 197.744L1171.92 197.462L1173.47 200.983L1171.36 201.265L1169.95 198.026Z",
    fill: "#FFFAFA"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M1159.4 191.971L1158.27 194.083L1156.16 191.407L1157.85 189.717L1155.46 187.183L1156.3 185.07L1158.56 187.746L1158.27 184.507L1160.95 186.056L1160.67 188.872L1162.92 188.732L1163.76 191.689L1161.37 191.407L1162.92 194.928L1160.81 195.21L1159.4 191.971Z",
    fill: "#FFFAFA"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M1148.85 185.774L1147.73 187.887L1145.62 185.211L1147.3 183.521L1144.91 180.986L1145.76 178.874L1148.01 181.55L1147.73 178.311L1150.4 179.86L1150.12 182.676L1152.09 182.817L1152.93 185.774L1150.54 185.493L1152.09 189.013L1149.98 189.295L1148.85 185.774Z",
    fill: "#FFFAFA"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M1138.16 179.719L1137.03 181.831L1134.92 179.155L1136.61 177.465L1134.22 174.931L1135.07 172.818L1137.32 175.494L1137.03 172.255L1139.71 173.804L1139.43 176.62L1141.68 176.48L1142.52 179.437L1140.13 179.155L1141.68 182.676L1139.57 182.958L1138.16 179.719Z",
    fill: "#FFFAFA"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M1127.61 173.522L1126.49 175.635L1124.38 172.959L1126.06 171.269L1123.67 168.734L1124.52 166.622L1126.77 169.298L1126.49 166.059L1129.16 167.608L1128.88 170.424L1131.13 170.283L1131.97 173.241L1129.58 172.959L1131.13 176.48L1129.02 176.761L1127.61 173.522Z",
    fill: "#FFFAFA"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M1169.95 228.162L1168.82 230.275L1166.71 227.599L1168.4 225.909L1166.01 223.374L1166.85 221.262L1169.11 223.938L1168.82 220.699L1171.5 222.248L1171.22 225.064L1173.47 224.923L1174.31 227.881L1171.92 227.599L1173.47 231.12L1171.36 231.401L1169.95 228.162Z",
    fill: "#FFFAFA"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M1159.4 222.107L1158.27 224.219L1156.16 221.543L1157.85 219.854L1155.46 217.319L1156.3 215.206L1158.56 217.882L1158.27 214.643L1160.95 216.192L1160.67 219.009L1162.92 218.868L1163.76 221.825L1161.37 221.543L1162.92 225.064L1160.81 225.346L1159.4 222.107Z",
    fill: "#FFFAFA"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M1148.85 216.052L1147.73 218.164L1145.62 215.488L1147.3 213.798L1144.91 211.264L1145.76 209.151L1148.01 211.827L1147.73 208.588L1150.4 210.137L1150.12 212.953L1152.37 212.813L1153.21 215.77L1150.82 215.488L1152.37 219.009L1150.26 219.291L1148.85 216.052Z",
    fill: "#FFFAFA"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M1138.16 209.855L1137.03 211.968L1134.92 209.292L1136.61 207.602L1134.22 205.067L1135.07 202.955L1137.32 205.631L1137.03 202.392L1139.71 203.941L1139.43 206.757L1141.68 206.616L1142.52 209.574L1140.13 209.292L1141.68 212.813L1139.57 213.094L1138.16 209.855Z",
    fill: "#FFFAFA"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M1127.61 203.8L1126.49 205.912L1124.38 203.236L1126.06 201.546L1123.67 199.012L1124.52 196.899L1126.77 199.575L1126.49 196.336L1129.16 197.885L1128.88 200.702L1131.13 200.561L1131.97 203.518L1129.58 203.236L1131.13 206.757L1129.02 207.039L1127.61 203.8Z",
    fill: "#FFFAFA"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1123.81 512.065L1109.75 520.092L1095.82 512.065L1109.75 504.038L1123.81 512.065Z",
    fill: "#A86FD7"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M1170.23 449.398L1156.31 457.425L1142.38 449.398L1156.31 441.371L1170.23 449.398Z",
    fill: "#A86FD7"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M1108.34 235.486L1094.28 243.513L1080.35 235.486L1094.28 227.458L1108.34 235.486Z",
    fill: "#A86FD7"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1185.7 476.295L1171.78 484.322L1157.85 476.295L1171.78 468.127L1185.7 476.295Z",
    fill: "#A86FD7"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1356.04 431.513L1342.11 439.54L1328.19 431.513L1342.11 423.486L1356.04 431.513Z",
    fill: "#A86FD7"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M999.896 536.944L985.971 544.971L972.046 536.944L985.971 528.917L999.896 536.944Z",
    fill: "#A86FD7"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1027.75 305.475L1013.82 313.502L999.896 305.475L1013.82 297.448L1027.75 305.475Z",
    fill: "#A86FD7"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M964.31 444.384L950.385 452.411L936.46 444.384L950.385 436.357L964.31 444.384Z",
    fill: "#A86FD7"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1365.32 305.194L1351.39 313.361L1337.47 305.194L1351.39 297.167L1365.32 305.194Z",
    fill: "#A86FD7"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M936.459 319.558L922.534 327.585L908.469 319.558L922.534 311.531L936.459 319.558Z",
    fill: "#A86FD7"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M986.533 288.717C986.111 288.717 985.689 288.576 985.267 288.435L926.473 254.496C925.629 254.074 925.207 253.229 925.207 252.243C925.207 251.398 925.629 250.553 926.473 249.99L985.267 216.051C986.111 215.629 987.096 215.629 987.799 216.051L1046.59 249.99C1047.44 250.412 1047.86 251.257 1047.86 252.243C1047.86 253.088 1047.44 253.933 1046.59 254.496L987.799 288.435C987.377 288.717 986.955 288.717 986.533 288.717ZM928.301 252.243L986.533 285.9L1044.76 252.243L986.392 218.586L928.301 252.243Z",
    fill: "url(#paint27_linear_1842_785)"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M1039.42 239.992V229.289L986.533 258.44L933.506 229.289V239.992L986.533 270.551L1039.42 239.992Z",
    fill: "url(#paint28_linear_1842_785)"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M986.533 259.848L933.506 229.289L986.393 198.73L1039.42 229.289L986.533 259.848Z",
    fill: "url(#paint29_linear_1842_785)"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M986.533 259.003L934.35 228.866L933.506 229.289L986.533 259.848L1039.42 229.289L1038.58 228.866L986.533 259.003Z",
    fill: "#FFFAFA"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M986.533 248.159L953.76 229.289L986.533 210.418L1019.16 229.289L986.533 248.159Z",
    fill: "#4D2072"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M986.533 248.159L953.76 229.289L986.533 210.418L1019.16 229.289L986.533 248.159Z",
    fill: "url(#paint30_linear_1842_785)"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M986.532 183.943L1019.16 202.814V229.289L986.532 210.418V183.943Z",
    fill: "url(#paint31_linear_1842_785)"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M986.533 210.418L953.76 229.289V202.814L986.533 183.943V210.418Z",
    fill: "url(#paint32_linear_1842_785)"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M986.533 221.684L953.76 202.814L986.533 183.943L1019.16 202.814L986.533 221.684Z",
    fill: "url(#paint33_linear_1842_785)"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M986.532 221.684V248.159L1019.16 229.289V202.814L986.532 221.684Z",
    fill: "url(#paint34_linear_1842_785)"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M953.76 202.814V229.289L986.533 248.159V221.684L953.76 202.814Z",
    fill: "url(#paint35_linear_1842_785)"
  }))), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M1075.57 306.179C1075.29 306.179 1075.15 306.179 1074.87 306.038L1015.23 271.536C1014.67 271.114 1014.38 270.41 1014.81 269.705C1015.23 269.142 1015.93 268.861 1016.63 269.283L1076.27 303.785C1076.84 304.207 1077.12 304.912 1076.69 305.616C1076.41 306.038 1075.99 306.179 1075.57 306.179Z",
    fill: "url(#paint36_linear_1842_785)"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M966.42 384.619C966.138 384.619 965.998 384.619 965.716 384.478L862.615 324.346C862.193 324.064 861.912 323.642 861.912 323.078C861.912 322.515 862.193 322.093 862.615 321.811L957.136 270.41C957.84 269.987 958.683 270.269 959.105 270.973C959.527 271.677 959.246 272.522 958.543 272.945L866.132 323.219L967.123 382.084C967.826 382.506 967.967 383.351 967.685 384.055C967.404 384.337 966.982 384.619 966.42 384.619Z",
    fill: "url(#paint37_linear_1842_785)"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M1092.45 205.489L1204.27 270.128C1207.36 271.959 1209.75 269.987 1209.75 265.903V203.236C1209.75 199.152 1207.22 194.364 1204.27 192.674L1092.45 128.036C1089.35 126.205 1086.96 128.177 1086.96 132.261V194.928C1086.96 199.012 1089.35 203.659 1092.45 205.489Z",
    fill: "url(#paint38_linear_1842_785)"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M1192.17 454.327L1027.75 359.27C1026.48 358.566 1025.78 357.299 1025.78 355.89C1025.78 354.482 1026.48 353.215 1027.75 352.511L1129.86 293.505L1130.71 293.083L1303.01 392.646C1304.28 393.35 1304.98 394.617 1304.98 396.025C1304.98 397.434 1304.28 398.701 1303.01 399.405L1207.79 454.468C1205.39 455.876 1202.72 456.58 1200.05 456.58C1197.24 456.439 1194.56 455.735 1192.17 454.327ZM1029.29 355.468C1029.01 355.609 1029.01 355.89 1029.01 356.031C1029.01 356.172 1029.01 356.454 1029.29 356.594L1193.72 451.651C1197.52 453.904 1202.3 453.904 1206.1 451.651L1301.32 396.589C1301.6 396.448 1301.6 396.166 1301.6 396.025C1301.6 395.884 1301.6 395.603 1301.32 395.462L1130.71 296.885L1029.29 355.468Z",
    fill: "url(#paint39_linear_1842_785)"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M1130.56 253.933L1153.49 117.897L1151.66 117.052L1154.48 115.503C1155.04 115.08 1155.74 115.221 1156.59 115.643L1339.72 221.403C1341.27 222.248 1342.39 224.501 1342.11 226.05L1319.04 363.213C1318.9 363.917 1318.62 364.34 1318.06 364.621L1315.39 366.17L1314.96 363.636H1315.11L1133.1 258.44C1131.41 257.736 1130.28 255.482 1130.56 253.933Z",
    fill: "url(#paint40_linear_1842_785)"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M1338.6 225.205L1341.55 223.938C1341.83 224.642 1342.11 225.487 1341.97 226.191L1318.9 363.354C1318.76 364.058 1318.48 364.48 1317.92 364.762L1315.25 366.311L1314.82 363.776H1314.96L1305.82 358.425L1338.6 225.205Z",
    fill: "url(#paint41_linear_1842_785)"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M1130 260.13L1313.14 365.889C1314.54 366.734 1315.81 366.171 1315.95 364.762L1339.02 227.599C1339.3 226.05 1338.17 223.797 1336.63 222.952L1153.63 117.334C1152.23 116.489 1150.96 117.052 1150.82 118.46L1127.75 255.623C1127.33 257.032 1128.45 259.285 1130 260.13Z",
    fill: "#44106F"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.51
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1156.02 126.064L1332.41 228.021L1310.6 357.158L1134.22 255.201L1156.02 126.064Z",
    fill: "#8151A8"
  }))), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M1014.95 325.191L1024.93 330.401L1125.08 272.522C1126.77 271.537 1129.72 271.678 1131.55 272.804L1304.27 372.649C1305.96 371.663 1313.42 368.142 1313.42 368.142L1309.76 377.718C1309.62 378.141 1309.34 378.563 1308.78 378.845L1203.28 439.822C1201.6 440.808 1198.64 440.667 1196.81 439.541L1020.01 337.302C1019.16 336.879 1018.74 336.316 1018.46 335.753L1014.95 325.191Z",
    fill: "url(#paint42_linear_1842_785)"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M1016.49 326.74L1197.66 431.513C1199.63 432.64 1202.58 432.781 1204.41 431.795L1312.57 369.269C1314.26 368.283 1314.12 366.593 1312.15 365.326L1130.99 260.552C1129.02 259.426 1126.06 259.285 1124.24 260.271L1016.07 322.797C1014.24 323.923 1014.52 325.613 1016.49 326.74Z",
    fill: "url(#paint43_linear_1842_785)"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M1016.49 325.754L1197.66 430.528C1199.63 431.654 1202.58 431.795 1204.41 430.809L1312.57 368.283C1313.14 368.002 1313.42 367.579 1313.56 367.157C1313.84 368.002 1313.56 368.846 1312.57 369.41L1204.41 431.936C1202.72 432.922 1199.63 432.781 1197.66 431.654L1016.49 326.881C1015.23 326.177 1014.66 325.05 1014.95 324.205C1015.09 324.628 1015.65 325.191 1016.49 325.754Z",
    fill: "#FFFAFA"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M1252.37 408.841V406.869C1252.37 406.728 1252.23 406.587 1252.09 406.728L1245.06 410.812C1244.92 410.953 1244.78 411.094 1244.78 411.235V413.206C1244.78 413.347 1244.92 413.488 1245.06 413.347L1252.09 409.263C1252.23 409.263 1252.37 409.122 1252.37 408.841Z",
    fill: "#6A26A3"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M1241.82 414.896V412.924C1241.82 412.783 1241.68 412.643 1241.54 412.783L1234.51 416.867C1234.37 417.008 1234.23 417.149 1234.23 417.29V419.261C1234.23 419.402 1234.37 419.543 1234.51 419.402L1241.54 415.318C1241.82 415.318 1241.82 415.177 1241.82 414.896Z",
    fill: "#6A26A3"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M1284.3 363.495L1133.66 276.465C1132.67 275.902 1131.41 275.902 1130.42 276.465L1076.83 307.588C1076.13 308.01 1076.13 309.137 1076.83 309.559L1227.34 396.589C1228.32 397.152 1229.59 397.152 1230.57 396.589L1284.3 365.607C1285.15 365.044 1285.15 363.918 1284.3 363.495Z",
    fill: "#BB88E4"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M1284.3 365.466L1283.74 365.748L1133.66 279C1132.67 278.437 1131.41 278.437 1130.42 279L1077.4 309.7L1076.83 309.418C1076.13 308.996 1076.13 307.869 1076.83 307.447L1130.42 276.324C1131.41 275.761 1132.67 275.761 1133.66 276.324L1284.3 363.354C1285.15 363.917 1285.15 365.044 1284.3 365.466Z",
    fill: "#481B6C"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M1126.49 284.211L1257.3 359.834L1263.06 356.454L1132.25 280.831L1126.49 284.211Z",
    fill: "#44106F"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M1112.14 292.519L1234.93 363.495L1240.7 360.115L1118.05 289.14L1112.14 292.519Z",
    fill: "#44106F"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M1102.86 297.871L1247.31 381.38L1253.22 378L1108.76 294.491L1102.86 297.871Z",
    fill: "#44106F"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M1093.57 303.222L1238.03 386.731L1243.93 383.351L1099.48 299.842L1093.57 303.222Z",
    fill: "#44106F"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M1084.29 308.574L1228.74 392.083L1234.65 388.703L1090.2 305.194L1084.29 308.574Z",
    fill: "#44106F"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M1265.17 364.481L1270.94 367.861L1276.85 364.481L1270.94 361.101L1265.17 364.481Z",
    fill: "#44106F"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M1244.64 369.128L1256.73 376.029L1262.5 372.649L1250.54 365.749L1244.64 369.128Z",
    fill: "#44106F"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M1127.89 384.478L1087.24 360.96C1085.7 359.974 1085.7 358.566 1087.24 357.58L1114.95 341.526C1116.5 340.541 1119.17 340.541 1120.72 341.526L1161.37 365.044C1162.92 366.03 1162.92 367.438 1161.37 368.424L1133.66 384.478C1132.11 385.464 1129.58 385.464 1127.89 384.478Z",
    fill: "url(#paint44_linear_1842_785)"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M1161.51 366.452L1120.86 342.935C1119.31 341.949 1116.64 341.949 1115.09 342.935L1087.38 358.989C1086.96 359.27 1086.54 359.552 1086.4 359.974C1085.98 359.13 1086.26 358.285 1087.38 357.58L1115.09 341.526C1116.64 340.541 1119.31 340.541 1120.86 341.526L1161.51 365.044C1162.63 365.748 1162.92 366.593 1162.49 367.438C1162.21 367.157 1161.93 366.734 1161.51 366.452Z",
    fill: "#481B6C"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.11
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1842_785",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1134,
    y: 126,
    width: 199,
    height: 232
  }, _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M1156.02 126.064L1332.41 228.021L1310.6 357.158L1134.22 255.201L1156.02 126.064Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1842_785)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1130.71 260.411L1311.87 365.184C1313.84 366.311 1316.79 366.452 1318.62 365.466L1426.79 302.94C1428.47 301.954 1428.33 300.264 1426.36 298.997L1245.06 194.364C1243.09 193.238 1240.14 193.097 1238.31 194.083L1130.14 256.609C1128.45 257.594 1128.74 259.284 1130.71 260.411Z",
    fill: "url(#paint45_linear_1842_785)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1312.43 279.282L1271.78 255.764C1270.24 254.778 1270.24 253.37 1271.78 252.384L1299.63 236.33C1301.18 235.344 1303.85 235.344 1305.4 236.33L1346.05 259.848C1347.6 260.834 1347.6 262.242 1346.05 263.228L1318.34 279.282C1316.51 280.127 1313.98 280.127 1312.43 279.282Z",
    fill: "url(#paint46_linear_1842_785)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1345.91 261.256L1305.4 237.738C1303.85 236.753 1301.18 236.753 1299.63 237.738L1271.92 253.792C1271.5 254.074 1271.08 254.356 1270.94 254.778C1270.52 253.933 1270.8 253.088 1271.92 252.384L1299.63 236.33C1301.18 235.344 1303.85 235.344 1305.4 236.33L1346.05 259.848C1347.17 260.552 1347.46 261.397 1347.03 262.242C1346.75 261.819 1346.47 261.538 1345.91 261.256Z",
    fill: "#481B6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1363.77 315.896L1213.13 228.866C1212.15 228.303 1210.88 228.303 1209.89 228.866L1156.3 259.989C1155.6 260.411 1155.6 261.538 1156.3 261.96L1306.81 348.99C1307.79 349.553 1309.06 349.553 1310.04 348.99L1363.77 318.008C1364.62 317.445 1364.62 316.318 1363.77 315.896Z",
    fill: "#BB88E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1363.77 317.867L1363.21 318.149L1213.13 231.542C1212.15 230.979 1210.88 230.979 1209.89 231.542L1156.87 262.242L1156.3 261.96C1155.6 261.538 1155.6 260.411 1156.3 259.989L1209.89 228.866C1210.88 228.303 1212.15 228.303 1213.13 228.866L1363.77 315.896C1364.62 316.318 1364.62 317.445 1363.77 317.867Z",
    fill: "#481B6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1170.37 257.876L1301.6 333.64L1296.4 336.597L1165.17 260.833L1170.37 257.876Z",
    fill: "#44106F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1184.15 249.849L1308.92 321.951L1303.71 324.909L1178.95 252.806L1184.15 249.849Z",
    fill: "#44106F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1318.2 327.303L1329.87 334.062L1324.67 337.02L1313 330.26L1318.2 327.303Z",
    fill: "#44106F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1307.93 337.301L1315.95 341.948L1310.74 345.047L1302.73 340.259L1307.93 337.301Z",
    fill: "#44106F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1192.88 244.779L1338.45 328.992L1333.25 331.95L1187.67 247.877L1192.88 244.779Z",
    fill: "#44106F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1201.46 239.851L1347.17 324.064L1341.97 327.021L1196.25 242.808L1201.46 239.851Z",
    fill: "#44106F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1210.18 234.781L1355.75 318.994L1350.69 321.951L1204.97 237.738L1210.18 234.781Z",
    fill: "#44106F"
  })))), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M1316.23 235.626L1319.61 237.879L1320.03 235.345L1316.65 233.091L1316.23 235.626Z",
    fill: "#CA89FF"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M1313.28 253.229L1316.79 255.341L1319.33 240.273L1315.81 238.02L1313.28 253.229Z",
    fill: "#CA89FF"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M1312.01 261.538L1315.39 263.791L1316.37 257.736L1312.85 255.482L1312.01 261.538Z",
    fill: "#CA89FF"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M1310.46 270.269L1313.98 272.381L1314.96 266.467L1311.45 264.213L1310.46 270.269Z",
    fill: "#CA89FF"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M1309.62 240.696L1313.14 242.949L1314.12 236.893L1310.6 234.64L1309.62 240.696Z",
    fill: "#CA89FF"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M1307.79 252.244L1311.17 254.497L1312.71 245.625L1309.2 243.372L1307.79 252.244Z",
    fill: "#CA89FF"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M1305.96 262.805L1309.48 265.058L1310.75 257.454L1307.23 255.201L1305.96 262.805Z",
    fill: "#CA89FF"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M1309.06 278.859L1312.57 281.112L1313.56 275.057L1310.04 272.804L1309.06 278.859Z",
    fill: "#CA89FF"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M1311.03 232.387L1314.4 234.64L1314.82 231.965L1311.45 229.711L1311.03 232.387Z",
    fill: "#CA89FF"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M1305.12 285.619L1311.17 289.562L1311.59 287.027L1305.54 283.084L1305.12 285.619Z",
    fill: "#CA89FF"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M1090.34 479.253L948.837 397.434C947.712 396.729 947.149 395.744 947.149 394.758C947.149 393.49 947.993 392.364 949.4 391.519L978.656 374.479C980.907 373.212 984.142 373.071 986.111 374.197L1127.75 456.017C1128.88 456.721 1129.44 457.707 1129.44 458.692C1129.44 459.96 1128.6 461.086 1127.19 461.931L1097.79 478.971C1096.53 479.675 1095.12 479.957 1093.57 479.957C1092.45 479.957 1091.32 479.816 1090.34 479.253ZM980.063 376.873L950.666 393.913C949.963 394.335 949.822 394.617 949.822 394.758C949.822 394.758 949.963 394.899 950.244 395.04L1091.74 476.859C1092.87 477.563 1095.12 477.422 1096.53 476.577L1125.92 459.537C1126.63 459.115 1126.77 458.833 1126.77 458.692C1126.77 458.692 1126.63 458.551 1126.35 458.411L984.845 376.592C984.283 376.31 983.579 376.169 982.876 376.169C981.891 376.169 980.907 376.451 980.063 376.873Z",
    fill: "url(#paint47_linear_1842_785)"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M1006.37 327.162C1010.02 329.275 1013.54 332.373 1016.77 335.893C1021.13 321.952 1034.36 317.586 1050.11 326.599C1063.05 334.063 1074.44 348.849 1080.35 364.481C1082.32 364.481 1084.57 365.185 1086.82 366.593C1095.26 371.522 1102.15 383.351 1102.15 393.209C1102.15 393.35 1102.15 393.631 1102.15 393.772C1104.54 393.913 1107.22 394.758 1110.03 396.448C1120.86 402.644 1129.58 417.994 1129.58 430.387C1129.58 442.92 1120.86 447.99 1110.03 441.653L1006.37 381.802C993.285 374.198 982.735 355.89 982.735 340.681C982.735 325.754 993.285 319.558 1006.37 327.162Z",
    fill: "url(#paint48_linear_1842_785)"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M1006.37 327.162C1008.48 328.43 1010.59 329.979 1012.55 331.669L1024.09 324.909C1030.42 320.403 1039.7 320.684 1049.97 326.599C1062.91 334.063 1074.3 348.849 1080.21 364.481C1082.18 364.481 1084.43 365.185 1086.68 366.593C1095.12 371.522 1102.01 383.351 1102.01 393.209C1102.01 393.35 1102.01 393.631 1102.01 393.772C1104.4 393.913 1107.08 394.758 1109.89 396.448C1120.72 402.644 1129.44 417.994 1129.44 430.387C1129.44 436.583 1127.33 440.949 1123.81 443.061H1123.67L1095.26 459.537L1089.07 429.683L1006.08 381.802C993.003 374.198 982.454 355.89 982.454 340.681C982.735 325.754 993.285 319.558 1006.37 327.162Z",
    fill: "url(#paint49_radial_1842_785)"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M960.793 342.371L989.627 325.613C993.988 323.078 999.895 323.36 1006.51 327.162C1008.62 328.43 1010.73 329.979 1012.7 331.669L1024.23 324.909C1030.56 320.403 1039.84 320.684 1050.11 326.599C1063.05 334.063 1074.44 348.849 1080.35 364.481C1082.32 364.481 1084.57 365.185 1086.82 366.593C1095.26 371.522 1102.15 383.351 1102.15 393.209C1102.15 393.35 1102.15 393.631 1102.15 393.772C1104.54 393.913 1107.22 394.758 1110.03 396.448C1120.86 402.644 1129.58 417.994 1129.58 430.387C1129.58 436.583 1127.47 440.949 1123.95 443.061H1123.81L1095.4 459.537L1089.21 429.683L1006.22 381.802C995.676 375.606 986.674 362.368 983.579 349.553L960.793 342.371Z",
    fill: "url(#paint50_linear_1842_785)"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M977.953 343.779C981.611 345.892 985.127 348.99 988.362 352.511C992.722 338.569 1005.94 334.203 1021.7 343.216C1034.64 350.68 1046.03 365.466 1051.94 381.098C1053.91 381.098 1056.16 381.802 1058.41 383.21C1066.85 388.139 1073.74 399.968 1073.74 409.826C1073.74 409.967 1073.74 410.249 1073.74 410.389C1076.13 410.53 1078.8 411.375 1081.62 413.065C1092.45 419.261 1101.17 434.611 1101.17 447.004C1101.17 459.537 1092.45 464.607 1081.62 458.27L977.953 398.279C964.872 390.674 954.323 372.367 954.323 357.158C954.323 341.949 964.872 336.175 977.953 343.779Z",
    fill: "url(#paint51_linear_1842_785)"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M987.377 353.074C984.283 349.553 980.766 346.455 976.968 344.343C970.639 340.681 964.731 340.259 960.512 342.512C964.872 339.555 971.061 339.836 977.953 343.779C981.469 345.751 984.845 348.567 987.799 351.947C987.518 352.229 987.518 352.651 987.377 353.074Z",
    fill: "#FFFAFA"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M1100.18 447.567C1100.18 435.034 1091.46 419.825 1080.63 413.629C1077.82 411.939 1075.15 411.094 1072.76 410.953C1072.76 410.812 1072.76 410.53 1072.76 410.39C1072.76 400.532 1065.86 388.703 1057.42 383.774C1055.03 382.366 1052.92 381.802 1050.95 381.661C1044.91 366.03 1033.65 351.243 1020.71 343.78C1011.29 338.287 1002.57 337.724 996.379 341.245C1002.71 337.161 1011.71 337.442 1021.7 343.216C1034.64 350.68 1046.03 365.467 1051.94 381.098C1053.91 381.098 1056.16 381.802 1058.41 383.21C1066.85 388.139 1073.74 399.969 1073.74 409.826C1073.74 409.967 1073.74 410.249 1073.74 410.39C1076.13 410.53 1078.8 411.375 1081.62 413.065C1092.45 419.262 1101.17 434.611 1101.17 447.004C1101.17 453.482 1098.92 457.848 1095.12 459.819C1098.35 457.707 1100.18 453.482 1100.18 447.567Z",
    fill: "#FFFAFA"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M1180.5 512.488L1183.03 510.798L1112.14 468.128L1110.59 470.522L1180.5 512.488Z",
    fill: "url(#paint52_linear_1842_785)"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M1283.46 510.093C1282.9 510.093 1282.47 509.812 1282.19 509.389C1281.77 508.685 1282.05 507.84 1282.76 507.418L1343.1 474.605L1255.61 423.627C1254.91 423.204 1254.76 422.359 1255.05 421.655C1255.47 420.951 1256.31 420.81 1257.02 421.092L1346.61 473.338C1347.04 473.62 1347.32 474.042 1347.32 474.605C1347.32 475.169 1347.04 475.591 1346.61 475.873L1284.02 509.812C1283.88 510.093 1283.6 510.093 1283.46 510.093Z",
    fill: "url(#paint53_linear_1842_785)"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M1234.79 600.221C1234.51 600.221 1234.37 600.221 1234.09 600.08L1131.83 540.934C1131.41 540.652 1131.13 540.23 1131.13 539.666C1131.13 539.103 1131.41 538.681 1131.83 538.399L1234.09 479.253C1234.51 478.971 1235.07 478.971 1235.49 479.253L1337.75 538.399C1338.17 538.681 1338.45 539.103 1338.45 539.666C1338.45 540.23 1338.17 540.652 1337.75 540.934L1235.49 600.08C1235.35 600.221 1235.07 600.221 1234.79 600.221ZM1135.35 539.807L1234.79 597.264L1334.24 539.807L1234.79 482.351L1135.35 539.807Z",
    fill: "url(#paint54_linear_1842_785)"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M1234.79 578.956L1302.73 539.807L1234.79 500.517L1166.85 539.807L1234.79 578.956Z",
    fill: "url(#paint55_linear_1842_785)"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M1217.49 517.698C1217.49 517.698 1216.37 518.824 1215.1 520.233C1213.83 521.641 1210.6 523.472 1209.05 524.317C1207.64 525.161 1201.17 529.809 1199.77 534.597C1198.36 539.385 1202.86 540.089 1207.5 539.385C1212.15 538.681 1216.65 534.456 1217.91 532.907C1219.18 531.358 1223.68 527.978 1229.45 525.161C1235.21 522.345 1231.84 518.261 1231.84 518.261L1217.49 517.698Z",
    fill: "#270841"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M1259.55 532.907C1259.55 532.907 1260.39 535.019 1260.67 537.836C1260.81 540.652 1261.09 546.567 1261.23 548.257C1261.38 549.947 1261.23 554.312 1258.14 558.255C1254.91 562.198 1253.36 563.888 1249.28 562.198C1245.2 560.508 1245.48 553.608 1246.33 550.087C1247.17 546.567 1248.01 538.681 1248.01 537.836C1248.01 536.991 1248.29 536.427 1248.29 536.427L1259.55 532.907Z",
    fill: "#270841"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M1205.39 436.442C1205.39 436.442 1205.54 467.846 1212.43 484.745C1212.43 484.745 1217.35 499.531 1217.49 516.993C1217.49 516.993 1216.23 519.951 1217.91 522.486C1219.6 525.02 1230.29 527.414 1232.26 519.528C1234.23 511.501 1233.95 496.433 1232.12 490.096C1230.29 483.759 1233.39 466.578 1233.39 466.578C1233.39 466.578 1236.34 468.55 1239.86 481.083C1243.37 493.616 1246.04 498.405 1247.31 501.925C1248.58 505.446 1249.28 526.429 1248.15 536.709C1248.15 536.709 1256.87 538.117 1259.41 534.033C1262.08 529.949 1263.34 508.403 1262.92 501.503C1262.5 494.602 1260.11 472.493 1260.67 465.733C1261.23 458.974 1262.78 453.481 1261.38 446.581C1259.97 439.681 1214.54 423.486 1214.54 423.486L1205.39 436.442Z",
    fill: "#44106F"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M1260.67 465.874C1261.23 459.114 1262.78 453.622 1261.38 446.722C1260.81 444.187 1254.06 440.244 1245.9 436.442C1231.84 434.752 1214.12 432.921 1212.85 433.062C1211.72 433.203 1208.77 434.188 1206.38 435.174L1205.39 436.582C1205.39 436.582 1205.39 438.554 1205.54 441.652C1208.77 442.779 1215.1 441.793 1215.1 441.793C1215.94 444.046 1221.15 451.932 1227.9 455.594C1234.65 459.114 1254.62 458.41 1255.75 459.819C1256.87 461.086 1256.59 478.407 1256.45 480.52C1256.31 482.773 1258 496.574 1259.55 508.685C1261.09 520.655 1258 535.16 1257.86 535.723C1258.56 535.301 1259.13 534.878 1259.55 534.174C1262.22 530.09 1263.49 508.544 1263.06 501.643C1262.5 494.743 1260.11 472.634 1260.67 465.874Z",
    fill: "#270841"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M1223.26 334.062C1223.26 334.062 1212.99 336.175 1209.61 336.879C1209.05 337.02 1208.63 337.442 1208.35 337.865C1207.36 340.4 1204.69 348.004 1206.24 359.552C1208.21 373.634 1207.22 382.929 1207.22 382.929L1201.88 407.291C1201.88 407.291 1195.41 430.527 1195.83 431.231C1196.39 431.936 1209.19 442.216 1213.27 440.948C1217.35 439.681 1216.08 437.287 1216.08 437.287C1216.08 437.287 1219.04 454.327 1233.67 454.467C1248.43 454.608 1260.39 455.031 1263.06 449.116C1265.74 443.201 1263.2 418.135 1260.81 408.136C1258.42 398.138 1252.8 378.281 1252.8 378.281L1274.88 354.904L1256.87 340.399C1256.87 340.399 1252.65 332.091 1250.97 330.964C1249.14 329.838 1248.15 330.683 1248.15 330.683L1223.26 334.062Z",
    fill: "#8151A8"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M1213.83 435.597C1213.83 436.442 1213.27 437.709 1210.6 438.554C1207.79 439.399 1200.89 435.034 1196.25 431.654C1198.5 433.625 1209.61 442.075 1213.41 440.948C1214.26 440.667 1214.82 440.385 1215.24 440.103C1214.54 438.132 1213.97 436.442 1213.83 435.597Z",
    fill: "url(#paint56_linear_1842_785)"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M1263.2 447.144C1260.39 453.341 1247.73 453.059 1232.26 452.777C1228.32 452.777 1225.23 451.51 1222.7 449.82C1225.37 452.496 1228.88 454.467 1233.95 454.467C1248.72 454.608 1260.67 455.031 1263.34 449.116C1264.19 447.144 1264.47 443.201 1264.47 438.272C1264.33 442.356 1263.91 445.455 1263.2 447.144Z",
    fill: "url(#paint57_linear_1842_785)"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M1250.69 330.823C1250.69 330.823 1254.34 335.47 1248.72 341.526C1245.34 345.187 1239.29 353.214 1234.23 361.664C1230.99 366.874 1228.18 369.691 1226.49 374.197C1226.49 374.197 1226.35 368.846 1226.35 360.396C1226.35 352.51 1226.49 344.342 1226.92 342.23C1227.76 338.005 1246.61 328.711 1250.69 330.823Z",
    fill: "#ECD6FF"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M1236.2 344.202C1236.2 344.202 1234.23 345.328 1233.53 345.187C1232.82 345.047 1230.71 342.934 1230.71 342.934C1230.71 342.934 1225.37 342.653 1224.8 340.399C1224.24 338.146 1223.96 335.752 1223.4 334.626C1222.84 333.358 1220.73 327.584 1220.73 325.331C1220.73 323.078 1221.01 318.853 1220.02 316.6C1219.04 314.347 1218.33 292.378 1239.43 293.505C1260.53 294.631 1253.5 316.459 1253.5 316.459C1253.5 316.459 1255.05 317.163 1254.06 319.98C1253.08 322.796 1252.8 323.078 1252.37 324.486C1251.81 325.894 1251.67 326.739 1250.26 327.866L1249.84 330.401C1249.84 330.401 1250.69 334.344 1248.01 338.146C1245.34 342.23 1236.2 344.202 1236.2 344.202Z",
    fill: "#FCD1C5"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M1209.05 337.161C1209.05 337.161 1206.8 337.442 1199.06 355.749C1194.7 365.889 1188.09 376.451 1186.69 384.055C1185.14 391.66 1185.7 399.828 1187.25 400.532C1188.66 401.095 1214.68 411.657 1222.84 414.896C1223.26 415.037 1223.82 414.755 1223.82 414.333L1226.35 401.658L1210.18 394.899C1210.18 394.899 1207.22 390.956 1204.27 389.547C1204.27 389.547 1207.64 383.633 1207.5 381.943C1207.36 380.253 1208.21 363.213 1206.52 356.313C1204.83 349.131 1209.05 337.161 1209.05 337.161Z",
    fill: "#44106F"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M1217.35 386.026C1217.35 386.026 1215.1 384.477 1214.54 384.196C1213.97 383.914 1211.02 382.928 1210.46 382.647C1210.04 382.506 1208.35 382.506 1207.36 382.647C1207.08 382.647 1206.8 382.787 1206.66 383.069C1205.96 384.337 1203.85 387.998 1204.13 389.547C1204.13 389.547 1209.47 393.068 1210.04 394.617L1210.88 394.758C1210.88 394.898 1214.82 387.153 1217.35 386.026Z",
    fill: "#FCD1C5"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M1260.95 408.136C1260.39 405.742 1259.69 402.785 1258.84 399.687L1225.51 413.065C1225.51 413.065 1235.07 425.457 1252.51 425.176C1257.3 425.035 1260.81 423.486 1263.34 422.078C1262.5 416.585 1261.8 411.516 1260.95 408.136Z",
    fill: "#44106F"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M1275.02 355.045C1275.02 355.045 1266.3 356.031 1258.98 367.016C1251.67 378 1246.18 390.815 1246.18 390.815L1245.9 392.223C1245.2 396.025 1241.12 398.138 1237.6 396.448C1230.29 392.927 1219.32 387.576 1217.35 386.027C1217.35 386.027 1210.74 389.547 1208.63 398.138C1207.08 405.038 1207.36 405.038 1207.36 405.038C1207.36 405.038 1236.34 419.543 1247.73 419.684C1259.13 419.825 1274.32 382.929 1276.14 375.183C1277.97 367.438 1279.94 357.299 1275.02 355.045Z",
    fill: "#44106F"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M1275.02 355.045C1275.02 355.045 1266.3 356.031 1258.98 367.016C1251.67 378 1246.18 390.815 1246.18 390.815L1245.9 392.223C1245.2 396.025 1241.12 398.138 1237.6 396.448C1230.29 392.927 1219.32 387.576 1217.35 386.027C1217.35 386.027 1210.74 389.547 1208.63 398.138C1207.08 405.038 1207.36 405.038 1207.36 405.038C1207.36 405.038 1236.34 419.543 1247.73 419.684C1259.13 419.825 1274.32 382.929 1276.14 375.183C1277.97 367.438 1279.94 357.299 1275.02 355.045Z",
    fill: "#541E81"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M1241.82 398.278C1241.82 398.278 1245.48 401.799 1247.17 399.968C1248.86 398.137 1248.29 397.856 1248.29 397.856C1248.29 397.856 1251.67 397.856 1252.09 395.884C1252.51 393.772 1254.2 394.899 1254.34 392.645C1254.48 390.251 1251.67 390.674 1251.67 390.674L1241.82 398.278Z",
    fill: "#8151A8"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M1237.46 396.307C1237.46 396.307 1238.45 395.321 1239.86 394.335C1241.26 393.208 1243.37 388.702 1243.79 388.28C1244.22 387.857 1248.72 384.618 1250.83 384.618C1252.94 384.618 1251.25 387.012 1250.83 387.294C1250.26 387.575 1248.15 388.561 1248.15 388.561C1248.15 388.561 1245.9 390.251 1245.76 390.533C1245.48 390.814 1251.67 390.251 1252.65 390.814C1253.64 391.378 1253.36 393.068 1252.65 393.49C1251.95 393.913 1251.39 393.913 1251.39 393.913C1251.39 393.913 1252.09 395.743 1250.12 396.588C1248.29 397.433 1247.87 396.87 1247.87 396.87C1247.87 396.87 1247.59 400.109 1244.64 399.405L1237.46 396.307Z",
    fill: "#FCD1C5"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M1220.16 305.475C1220.16 305.475 1217.21 314.206 1224.52 311.953C1231.84 309.7 1238.59 305.616 1240.84 307.306C1242.53 308.573 1242.39 312.235 1242.25 313.924C1242.25 314.488 1242.39 315.051 1242.67 315.614L1244.78 318.853C1245.06 319.276 1245.2 319.698 1245.2 320.121L1245.34 322.374C1245.34 322.937 1245.76 323.36 1246.32 323.36H1246.89C1247.45 323.36 1247.87 323.078 1248.01 322.515L1248.72 319.276C1248.72 319.276 1250.54 315.051 1254.06 316.741C1254.06 316.741 1256.59 313.502 1255.89 306.602C1255.33 299.56 1252.37 292.378 1238.73 290.829C1224.8 289.139 1220.16 305.475 1220.16 305.475Z",
    fill: "#341C1C"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M1239.85 352.088L1237.89 350.398C1237.89 350.398 1235.92 351.947 1235.21 353.637C1234.37 355.327 1235.07 360.537 1235.07 360.537L1234.37 361.523L1233.67 360.115L1233.24 353.778C1233.24 353.778 1234.09 349.131 1234.09 348.99C1234.23 348.849 1238.03 349.553 1238.03 349.553C1238.03 349.553 1239.15 350.821 1239.85 352.088Z",
    fill: "#7A30B6"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M1230.15 345.61C1230.15 345.61 1227.9 345.751 1226.92 346.455C1226.92 346.455 1229.17 346.596 1229.59 346.736C1230.01 346.736 1230.15 345.61 1230.15 345.61Z",
    fill: "#7A30B6"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M1234.23 346.173L1237.75 349.694C1237.75 349.694 1234.51 351.102 1233.53 353.918C1233.53 353.918 1229.59 354.623 1229.17 353.073C1228.74 351.524 1229.31 348.004 1228.88 346.314C1228.6 344.765 1234.23 346.173 1234.23 346.173Z",
    fill: "#44106F"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M1229.45 353.074C1229.45 353.074 1228.74 356.031 1227.9 357.298C1227.2 358.566 1226.35 359.833 1226.35 359.833L1226.07 377.436C1226.07 377.436 1232.82 364.34 1234.37 361.664C1234.37 361.664 1234.37 355.186 1233.67 354.059C1233.1 352.792 1229.45 353.074 1229.45 353.074Z",
    fill: "#44106F"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M1247.45 327.584C1242.95 339.695 1230.85 343.075 1230.85 343.075C1230.85 343.075 1232.96 345.188 1233.67 345.328C1234.37 345.469 1236.34 344.343 1236.34 344.343C1236.34 344.343 1245.48 342.371 1248.29 338.569C1250.97 334.767 1250.12 330.823 1250.12 330.823L1250.55 328.289C1248.44 328.57 1247.45 327.584 1247.45 327.584Z",
    fill: "#F3B8AA"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M1256.73 342.089C1256.73 342.089 1254.91 347.863 1254.76 348.004C1254.48 348.286 1250.55 347.722 1250.55 347.722L1252.37 351.384C1252.37 351.384 1231.7 372.507 1227.34 383.914C1227.34 383.914 1237.18 369.409 1254.34 352.37L1252.09 348.708L1256.17 349.553L1256.73 342.089Z",
    fill: "#44106F"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M1223.96 336.175L1222.84 337.301L1224.1 338.569L1220.3 341.808C1220.3 341.808 1218.62 365.326 1222.69 381.098C1222.69 381.098 1216.93 366.593 1218.9 341.104L1222.98 338.428L1221.71 337.161L1223.96 336.175Z",
    fill: "#44106F"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M1233.39 466.719L1228.46 461.227C1230.71 464.748 1227.62 480.098 1227.2 483.618C1226.77 487.139 1229.73 494.602 1230.57 503.193C1231.56 511.783 1228.88 524.035 1228.88 524.035C1230.43 523.19 1231.56 521.782 1232.12 519.528C1234.09 511.501 1233.81 496.433 1231.98 490.096C1230.29 483.9 1233.39 466.719 1233.39 466.719Z",
    fill: "#270841"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M1247.87 419.543C1259.27 419.684 1274.46 382.788 1276.28 375.042C1276.57 373.775 1276.85 372.367 1277.13 371.099C1277.13 371.24 1273.89 379.126 1270.94 386.308C1267.85 393.49 1252.23 414.896 1244.5 416.022C1237.46 417.149 1212.71 404.756 1207.93 402.362C1207.36 405.038 1207.64 405.038 1207.64 405.038C1207.64 405.038 1236.48 419.402 1247.87 419.543Z",
    fill: "url(#paint58_linear_1842_785)"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M1246.47 323.219C1247.03 323.219 1247.45 322.937 1247.59 322.374L1248.29 319.135C1248.29 319.135 1250.12 314.91 1253.64 316.6C1253.64 316.6 1256.03 313.502 1255.61 307.024C1251.39 312.939 1242.39 315.473 1242.39 315.473L1244.5 318.712C1244.78 319.135 1244.92 319.557 1244.92 319.98L1245.06 322.233C1245.06 322.796 1245.48 323.219 1246.04 323.219H1246.47Z",
    fill: "#150A0A"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M1149.69 163.524L1215.38 201.547C1218.47 203.377 1220.87 208.025 1220.87 212.108V274.775C1220.87 278.859 1218.33 280.69 1215.38 279L1137.74 234.218L1149.69 163.524Z",
    fill: "#44106F"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M1088.65 127.754L1091.88 125.501C1092.87 124.797 1094.28 124.656 1095.82 125.642L1207.64 190.281C1210.74 192.111 1213.13 196.759 1213.13 200.842V263.509C1213.13 265.622 1212.43 267.171 1211.3 267.875L1207.93 270.269L1207.79 267.875C1207.64 267.875 1207.64 267.734 1207.5 267.734L1095.68 203.096C1092.59 201.265 1090.2 196.618 1090.2 192.534V129.726C1090.2 129.163 1090.2 128.599 1090.34 128.036L1088.65 127.754Z",
    fill: "url(#paint59_linear_1842_785)"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M1212.85 198.308L1183.31 215.347L1175.86 211.123L1209.33 191.689C1211.02 193.379 1212.29 195.773 1212.85 198.308Z",
    fill: "url(#paint60_linear_1842_785)"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M1092.45 205.489L1204.27 270.128C1207.36 271.959 1209.75 269.987 1209.75 265.903V203.236C1209.75 199.152 1207.22 194.364 1204.27 192.674L1092.45 128.036C1089.35 126.205 1086.96 128.177 1086.96 132.261V194.928C1086.96 199.012 1089.35 203.659 1092.45 205.489Z",
    fill: "url(#paint61_linear_1842_785)"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M1209.19 266.185V203.518C1209.19 199.434 1206.66 194.646 1203.71 192.956L1091.88 128.318C1090.62 127.614 1089.63 127.473 1088.65 127.895C1089.63 127.191 1091.04 127.191 1092.45 128.036L1204.27 192.675C1207.36 194.506 1209.75 199.153 1209.75 203.237V265.904C1209.75 268.438 1208.91 269.988 1207.5 270.551C1208.49 269.847 1209.19 268.298 1209.19 266.185Z",
    fill: "#FFFAFA"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M1102.86 165.918L1194.14 218.586C1194.84 219.009 1195.41 219.15 1195.83 218.586C1195.83 218.446 1195.83 218.305 1195.83 218.164V204.363C1195.83 203.237 1195.13 201.969 1194.42 201.547L1102.43 148.456C1102.29 148.456 1102.29 148.315 1102.15 148.315C1101.45 148.456 1101.45 149.019 1101.45 150.005L1101.17 163.242C1101.17 164.51 1102.01 165.496 1102.86 165.918Z",
    fill: "#A263D6"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M1102.58 196.055L1194 248.723C1194.7 249.145 1195.55 249.568 1195.69 248.723C1195.69 248.582 1195.69 248.441 1195.69 248.3V234.5C1195.69 233.373 1194.99 232.106 1194.28 231.683L1102.43 178.733C1102.29 178.733 1102.29 178.592 1102.15 178.592C1101.45 178.311 1101.31 179.296 1101.31 180.282V193.379C1101.17 194.365 1101.87 195.632 1102.58 196.055Z",
    fill: "#A263D6"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M1102.15 148.456C1102.15 148.597 1102.15 148.737 1102.15 148.878V162.679C1102.15 163.806 1102.86 165.073 1103.56 165.496L1195.55 218.586C1195.69 218.586 1195.69 218.586 1195.83 218.727C1195.69 219.572 1195.13 219.854 1194.42 219.431L1102.43 166.2C1101.59 165.777 1101.03 164.51 1101.03 163.383V149.582C1100.89 148.597 1101.45 148.174 1102.15 148.456Z",
    fill: "#FFFAFA"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M1102.15 178.592C1102.15 178.733 1102.15 178.874 1102.15 179.015V192.815C1102.15 193.942 1102.86 195.209 1103.56 195.632L1195.55 248.723C1195.69 248.723 1195.69 248.723 1195.83 248.864C1195.69 249.708 1195.13 249.99 1194.42 249.568L1102.43 196.477C1101.59 196.054 1101.03 194.787 1101.03 193.66V179.859C1100.89 178.874 1101.45 178.31 1102.15 178.592Z",
    fill: "#FFFAFA"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M1169.53 198.026L1168.4 200.138L1166.29 197.462L1167.98 195.773L1165.59 193.238L1166.43 191.125L1168.68 193.801L1168.4 190.562L1171.07 192.111L1170.79 194.928L1173.04 194.787L1173.89 197.744L1171.5 197.462L1173.04 200.983L1170.93 201.265L1169.53 198.026Z",
    fill: "#FFFAFA"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M1158.98 191.971L1157.85 194.083L1155.74 191.407L1157.43 189.717L1155.04 187.183L1155.88 185.07L1158.13 187.746L1157.85 184.507L1160.52 186.056L1160.24 188.872L1162.49 188.732L1163.34 191.689L1160.95 191.407L1162.49 194.928L1160.38 195.21L1158.98 191.971Z",
    fill: "#FFFAFA"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M1148.43 185.774L1147.3 187.887L1145.19 185.211L1146.88 183.521L1144.49 180.986L1145.33 178.874L1147.58 181.55L1147.3 178.311L1149.98 179.86L1149.69 182.676L1151.66 182.817L1152.51 185.774L1150.12 185.493L1151.66 189.013L1149.55 189.295L1148.43 185.774Z",
    fill: "#FFFAFA"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M1137.74 179.719L1136.61 181.831L1134.5 179.155L1136.19 177.465L1133.8 174.931L1134.64 172.818L1136.89 175.494L1136.61 172.255L1139.29 173.804L1139 176.62L1141.25 176.48L1142.1 179.437L1139.71 179.155L1141.25 182.676L1139.14 182.958L1137.74 179.719Z",
    fill: "#FFFAFA"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M1127.19 173.522L1126.06 175.635L1123.95 172.959L1125.64 171.269L1123.25 168.734L1124.09 166.622L1126.35 169.298L1126.06 166.059L1128.74 167.608L1128.46 170.424L1130.71 170.283L1131.55 173.241L1129.16 172.959L1130.71 176.48L1128.6 176.761L1127.19 173.522Z",
    fill: "#FFFAFA"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M1169.53 228.162L1168.4 230.275L1166.29 227.599L1167.98 225.909L1165.59 223.374L1166.43 221.262L1168.68 223.938L1168.4 220.699L1171.07 222.248L1170.79 225.064L1173.04 224.923L1173.89 227.881L1171.5 227.599L1173.04 231.12L1170.93 231.401L1169.53 228.162Z",
    fill: "#FFFAFA"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M1158.98 222.107L1157.85 224.219L1155.74 221.543L1157.43 219.854L1155.04 217.319L1155.88 215.206L1158.13 217.882L1157.85 214.643L1160.52 216.192L1160.24 219.009L1162.49 218.868L1163.34 221.825L1160.95 221.543L1162.49 225.064L1160.38 225.346L1158.98 222.107Z",
    fill: "#FFFAFA"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M1148.43 216.052L1147.3 218.164L1145.19 215.488L1146.88 213.798L1144.49 211.264L1145.33 209.151L1147.58 211.827L1147.3 208.588L1149.98 210.137L1149.69 212.953L1151.95 212.813L1152.79 215.77L1150.4 215.488L1151.95 219.009L1149.84 219.291L1148.43 216.052Z",
    fill: "#FFFAFA"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M1137.74 209.855L1136.61 211.968L1134.5 209.292L1136.19 207.602L1133.8 205.067L1134.64 202.955L1136.89 205.631L1136.61 202.392L1139.29 203.941L1139 206.757L1141.25 206.616L1142.1 209.574L1139.71 209.292L1141.25 212.813L1139.14 213.094L1137.74 209.855Z",
    fill: "#FFFAFA"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M1127.19 203.8L1126.06 205.912L1123.95 203.236L1125.64 201.546L1123.25 199.012L1124.09 196.899L1126.35 199.575L1126.06 196.336L1128.74 197.885L1128.46 200.702L1130.71 200.561L1131.55 203.518L1129.16 203.236L1130.71 206.757L1128.6 207.039L1127.19 203.8Z",
    fill: "#FFFAFA"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1123.39 512.065L1109.33 520.092L1095.4 512.065L1109.33 504.038L1123.39 512.065Z",
    fill: "#A86FD7"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M1169.81 449.398L1155.88 457.425L1141.96 449.398L1155.88 441.371L1169.81 449.398Z",
    fill: "#A86FD7"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M1107.92 235.486L1093.85 243.513L1079.93 235.486L1093.85 227.458L1107.92 235.486Z",
    fill: "#A86FD7"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1185.28 476.295L1171.36 484.322L1157.43 476.295L1171.36 468.127L1185.28 476.295Z",
    fill: "#A86FD7"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1355.62 431.513L1341.69 439.54L1327.77 431.513L1341.69 423.486L1355.62 431.513Z",
    fill: "#A86FD7"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1027.32 305.475L1013.4 313.502L999.474 305.475L1013.4 297.448L1027.32 305.475Z",
    fill: "#A86FD7"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M986.112 135.376L972.187 143.403L958.262 135.376L972.187 127.349L986.112 135.376Z",
    fill: "#A86FD7"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1364.9 305.194L1350.97 313.361L1337.05 305.194L1350.97 297.167L1364.9 305.194Z",
    fill: "#A86FD7"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M936.037 319.558L922.112 327.585L908.047 319.558L922.112 311.531L936.037 319.558Z",
    fill: "#A86FD7"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M986.111 288.717C985.689 288.717 985.267 288.576 984.845 288.435L926.051 254.496C925.207 254.074 924.785 253.229 924.785 252.243C924.785 251.398 925.207 250.553 926.051 249.99L984.845 216.051C985.689 215.629 986.674 215.629 987.377 216.051L1046.17 249.99C1047.02 250.412 1047.44 251.257 1047.44 252.243C1047.44 253.088 1047.02 253.933 1046.17 254.496L987.377 288.435C986.955 288.717 986.533 288.717 986.111 288.717ZM927.88 252.243L986.111 285.9L1044.34 252.243L985.971 218.586L927.88 252.243Z",
    fill: "url(#paint62_linear_1842_785)"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M1039 239.992V229.289L986.111 258.44L933.084 229.289V239.992L986.111 270.551L1039 239.992Z",
    fill: "url(#paint63_linear_1842_785)"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M986.111 259.848L933.084 229.289L985.971 198.73L1039 229.289L986.111 259.848Z",
    fill: "url(#paint64_linear_1842_785)"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M986.111 259.003L933.928 228.866L933.084 229.289L986.111 259.848L1039 229.289L1038.15 228.866L986.111 259.003Z",
    fill: "#FFFAFA"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M986.111 248.159L953.338 229.289L986.111 210.418L1018.74 229.289L986.111 248.159Z",
    fill: "#4D2072"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M986.111 248.159L953.338 229.289L986.111 210.418L1018.74 229.289L986.111 248.159Z",
    fill: "url(#paint65_linear_1842_785)"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M986.11 183.943L1018.74 202.814V229.289L986.11 210.418V183.943Z",
    fill: "url(#paint66_linear_1842_785)"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M986.111 210.418L953.338 229.289V202.814L986.111 183.943V210.418Z",
    fill: "url(#paint67_linear_1842_785)"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M986.111 221.684L953.338 202.814L986.111 183.943L1018.74 202.814L986.111 221.684Z",
    fill: "url(#paint68_linear_1842_785)"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M986.11 221.684V248.159L1018.74 229.289V202.814L986.11 221.684Z",
    fill: "url(#paint69_linear_1842_785)"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M953.338 202.814V229.289L986.111 248.159V221.684L953.338 202.814Z",
    fill: "url(#paint70_linear_1842_785)"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1062.7 627.829L1048.77 635.856L1034.85 627.829L1048.77 619.802L1062.7 627.829Z",
    fill: "#A86FD7"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M860.773 578.957L846.848 586.984L832.923 578.957L846.848 570.93L860.773 578.957Z",
    fill: "#A86FD7"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M1172.34 667.679L1158.42 675.706L1144.49 667.679L1158.42 659.652L1172.34 667.679Z",
    fill: "#A86FD7"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M849.82 469.254L835.895 477.281L821.97 469.254L835.895 461.227L849.82 469.254Z",
    fill: "#A86FD7"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1842_785",
    x1: 0,
    y1: 368.712,
    x2: 1512,
    y2: 368.712,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBDEFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1842_785",
    x1: 1015.12,
    y1: 269.734,
    x2: 1046.27,
    y2: 323.632,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E0B9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5199,
    stopColor: "#C383F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9A42E1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1842_785",
    x1: 862.334,
    y1: 327.48,
    x2: 968.293,
    y2: 327.48,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5199,
    stopColor: "#CA89FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A855EC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1842_785",
    x1: 1148.78,
    y1: 237.782,
    x2: 1182.35,
    y2: 179.696,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC8FE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2938,
    stopColor: "#C79BEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6399,
    stopColor: "#DEC0F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7EEFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1842_785",
    x1: 1305.28,
    y1: 374.808,
    x2: 1026.27,
    y2: 374.808,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DCB1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5199,
    stopColor: "#CA89FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AD5CEF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1842_785",
    x1: 1342.4,
    y1: 240.719,
    x2: 1130.9,
    y2: 240.719,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EAD0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6399,
    stopColor: "#EFDBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6ECFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1842_785",
    x1: 1342.4,
    y1: 295.023,
    x2: 1306.08,
    y2: 295.023,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC69FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3876,
    stopColor: "#CA89FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAD0FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1842_785",
    x1: 1314.06,
    y1: 356.068,
    x2: 1015.36,
    y2: 356.068,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B35DFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3876,
    stopColor: "#CA89FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EED9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1842_785",
    x1: 1213.7,
    y1: 346.096,
    x2: 914.833,
    y2: 346.096,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1BCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.541667,
    stopColor: "#E5C6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1842_785",
    x1: 1163.08,
    y1: 363.082,
    x2: 1086.58,
    y2: 363.082,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E0BAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6399,
    stopColor: "#E9CDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5E9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1842_785",
    x1: 1327.88,
    y1: 279.774,
    x2: 1029.02,
    y2: 279.774,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EAD1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6399,
    stopColor: "#F2E2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9E9FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5E8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1842_785",
    x1: 1347.55,
    y1: 257.81,
    x2: 1271.05,
    y2: 257.81,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8CCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6399,
    stopColor: "#F1DFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7EEFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_1842_785",
    x1: 1129.91,
    y1: 426.733,
    x2: 947.537,
    y2: 426.733,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DEB5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5199,
    stopColor: "#CA89FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9D4AE1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_1842_785",
    x1: 1130.08,
    y1: 412.926,
    x2: 983.139,
    y2: 412.926,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BE6FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3876,
    stopColor: "#CA89FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5C5FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint14_radial_1842_785",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1095.55 368.765) rotate(180) scale(70.096 70.1799)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8D54BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#53227A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_1842_785",
    x1: 1130.08,
    y1: 390.809,
    x2: 961.178,
    y2: 390.809,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AD57F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3876,
    stopColor: "#CA89FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAD0FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_1842_785",
    x1: 1101.6,
    y1: 429.479,
    x2: 954.655,
    y2: 429.479,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0BFF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#EBD2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6399,
    stopColor: "#EACFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0DDFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_1842_785",
    x1: 1183.39,
    y1: 490.333,
    x2: 1111.08,
    y2: 490.333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AF4DFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4801,
    stopColor: "#CA89FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E4C2FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_1842_785",
    x1: 1347.75,
    y1: 465.67,
    x2: 1255.37,
    y2: 465.67,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8CCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5199,
    stopColor: "#CA89FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A54AEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_1842_785",
    x1: 1131.59,
    y1: 539.769,
    x2: 1338.88,
    y2: 539.769,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8CBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5199,
    stopColor: "#CA89FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7209,
    stopColor: "#A76CD7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#723E9C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_1842_785",
    x1: 1254.3,
    y1: 570.314,
    x2: 1216.1,
    y2: 509.265,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5199,
    stopColor: "#CA89FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A83FFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_1842_785",
    x1: 1196.4,
    y1: 435.648,
    x2: 1215.92,
    y2: 437.264,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B152FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4801,
    stopColor: "#CA89FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8CBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_1842_785",
    x1: 1223.47,
    y1: 444.279,
    x2: 1264.32,
    y2: 447.661,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BD6CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4801,
    stopColor: "#CA89FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ECD6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_1842_785",
    x1: 1209,
    y1: 390.872,
    x2: 1275.43,
    y2: 396.372,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A940FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4801,
    stopColor: "#CA89FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ECD6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_1842_785",
    x1: 1198.57,
    y1: 235.676,
    x2: 1087.71,
    y2: 142.77,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B862FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.458333,
    stopColor: "#CA89FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EFDCFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_1842_785",
    x1: 1200.81,
    y1: 207.862,
    x2: 1188.7,
    y2: 197.714,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8CCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6399,
    stopColor: "#EDD8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7EEFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_1842_785",
    x1: 1148.78,
    y1: 237.782,
    x2: 1182.35,
    y2: 179.696,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC8FE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2938,
    stopColor: "#C79BEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6399,
    stopColor: "#DEC0F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7EEFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_1842_785",
    x1: 925.18,
    y1: 252.274,
    x2: 1047.75,
    y2: 252.274,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DEB5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5199,
    stopColor: "#CA89FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AA52F2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_1842_785",
    x1: 933.551,
    y1: 249.917,
    x2: 1008.96,
    y2: 249.917,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2473,
    stopColor: "#C073FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4363,
    stopColor: "#CA89FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E3C1FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_1842_785",
    x1: 933.551,
    y1: 229.279,
    x2: 1039.38,
    y2: 229.279,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9CDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6399,
    stopColor: "#F0DDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7EEFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_1842_785",
    x1: 953.751,
    y1: 229.279,
    x2: 1019.17,
    y2: 229.279,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E0BBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5199,
    stopColor: "#CA89FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AA43FD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_1842_785",
    x1: 986.462,
    y1: 206.598,
    x2: 1019.17,
    y2: 206.598,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DDB4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5199,
    stopColor: "#CA89FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AF4EFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_1842_785",
    x1: 953.751,
    y1: 206.598,
    x2: 986.463,
    y2: 206.598,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E0BBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5199,
    stopColor: "#CA89FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B458FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_1842_785",
    x1: 953.751,
    y1: 202.826,
    x2: 1019.17,
    y2: 202.826,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E0BBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5199,
    stopColor: "#CA89FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AB4FF7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_1842_785",
    x1: 986.463,
    y1: 225.507,
    x2: 1019.17,
    y2: 225.507,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E0B9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5199,
    stopColor: "#CA89FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A94FF2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_1842_785",
    x1: 953.751,
    y1: 225.507,
    x2: 986.463,
    y2: 225.507,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E7C9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5199,
    stopColor: "#CA89FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B663F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_1842_785",
    x1: 1014.69,
    y1: 269.734,
    x2: 1045.85,
    y2: 323.632,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E0B9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5199,
    stopColor: "#C383F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9A42E1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_1842_785",
    x1: 861.912,
    y1: 327.48,
    x2: 967.871,
    y2: 327.48,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5199,
    stopColor: "#CA89FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A855EC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_1842_785",
    x1: 1148.35,
    y1: 237.782,
    x2: 1181.93,
    y2: 179.696,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC8FE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2938,
    stopColor: "#C79BEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6399,
    stopColor: "#DEC0F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7EEFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_1842_785",
    x1: 1304.86,
    y1: 374.808,
    x2: 1025.84,
    y2: 374.808,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DCB1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5199,
    stopColor: "#CA89FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AD5CEF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_1842_785",
    x1: 1341.97,
    y1: 240.719,
    x2: 1130.48,
    y2: 240.719,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EAD0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6399,
    stopColor: "#EFDBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6ECFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_1842_785",
    x1: 1341.97,
    y1: 295.023,
    x2: 1305.66,
    y2: 295.023,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC69FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3876,
    stopColor: "#CA89FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAD0FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_1842_785",
    x1: 1313.64,
    y1: 356.068,
    x2: 1014.94,
    y2: 356.068,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B35DFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3876,
    stopColor: "#CA89FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EED9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_1842_785",
    x1: 1213.27,
    y1: 346.096,
    x2: 914.412,
    y2: 346.096,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1BCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.541667,
    stopColor: "#E5C6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_1842_785",
    x1: 1162.66,
    y1: 363.082,
    x2: 1086.16,
    y2: 363.082,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E0BAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6399,
    stopColor: "#E9CDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5E9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_1842_785",
    x1: 1327.46,
    y1: 279.774,
    x2: 1028.59,
    y2: 279.774,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EAD1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6399,
    stopColor: "#F2E2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9E9FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5E8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_1842_785",
    x1: 1347.13,
    y1: 257.81,
    x2: 1270.63,
    y2: 257.81,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8CCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6399,
    stopColor: "#F1DFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7EEFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_1842_785",
    x1: 1129.49,
    y1: 426.733,
    x2: 947.115,
    y2: 426.733,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DEB5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5199,
    stopColor: "#CA89FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9D4AE1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_1842_785",
    x1: 1129.66,
    y1: 412.926,
    x2: 982.717,
    y2: 412.926,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BE6FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3876,
    stopColor: "#CA89FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5C5FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint49_radial_1842_785",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1095.13 368.765) rotate(180) scale(70.096 70.1799)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8D54BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#53227A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_1842_785",
    x1: 1129.66,
    y1: 390.809,
    x2: 960.756,
    y2: 390.809,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AD57F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3876,
    stopColor: "#CA89FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAD0FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_1842_785",
    x1: 1101.18,
    y1: 429.479,
    x2: 954.233,
    y2: 429.479,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0BFF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#EBD2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6399,
    stopColor: "#EACFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0DDFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_1842_785",
    x1: 1182.96,
    y1: 490.333,
    x2: 1110.66,
    y2: 490.333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AF4DFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4801,
    stopColor: "#CA89FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E4C2FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_1842_785",
    x1: 1347.33,
    y1: 465.67,
    x2: 1254.95,
    y2: 465.67,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8CCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5199,
    stopColor: "#CA89FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A54AEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_1842_785",
    x1: 1131.17,
    y1: 539.769,
    x2: 1338.46,
    y2: 539.769,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8CBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5199,
    stopColor: "#CA89FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7209,
    stopColor: "#A76CD7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#723E9C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_1842_785",
    x1: 1253.88,
    y1: 570.314,
    x2: 1215.68,
    y2: 509.265,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5199,
    stopColor: "#CA89FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A83FFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_1842_785",
    x1: 1195.98,
    y1: 435.648,
    x2: 1215.5,
    y2: 437.264,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B152FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4801,
    stopColor: "#CA89FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8CBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_1842_785",
    x1: 1223.05,
    y1: 444.279,
    x2: 1263.9,
    y2: 447.661,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BD6CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4801,
    stopColor: "#CA89FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ECD6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_1842_785",
    x1: 1208.58,
    y1: 390.872,
    x2: 1275.01,
    y2: 396.372,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A940FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4801,
    stopColor: "#CA89FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ECD6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_1842_785",
    x1: 1198.15,
    y1: 235.676,
    x2: 1087.29,
    y2: 142.77,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B862FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.458333,
    stopColor: "#CA89FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EFDCFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear_1842_785",
    x1: 1200.38,
    y1: 207.862,
    x2: 1188.28,
    y2: 197.714,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8CCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6399,
    stopColor: "#EDD8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7EEFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear_1842_785",
    x1: 1148.35,
    y1: 237.782,
    x2: 1181.93,
    y2: 179.696,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC8FE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2938,
    stopColor: "#C79BEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6399,
    stopColor: "#DEC0F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7EEFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear_1842_785",
    x1: 924.758,
    y1: 252.274,
    x2: 1047.33,
    y2: 252.274,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DEB5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5199,
    stopColor: "#CA89FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AA52F2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint63_linear_1842_785",
    x1: 933.129,
    y1: 249.917,
    x2: 1008.54,
    y2: 249.917,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2473,
    stopColor: "#C073FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4363,
    stopColor: "#CA89FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E3C1FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint64_linear_1842_785",
    x1: 933.129,
    y1: 229.279,
    x2: 1038.95,
    y2: 229.279,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9CDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6399,
    stopColor: "#F0DDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7EEFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint65_linear_1842_785",
    x1: 953.33,
    y1: 229.279,
    x2: 1018.75,
    y2: 229.279,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E0BBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5199,
    stopColor: "#CA89FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AA43FD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint66_linear_1842_785",
    x1: 986.04,
    y1: 206.598,
    x2: 1018.75,
    y2: 206.598,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DDB4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5199,
    stopColor: "#CA89FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AF4EFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint67_linear_1842_785",
    x1: 953.33,
    y1: 206.598,
    x2: 986.042,
    y2: 206.598,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E0BBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5199,
    stopColor: "#CA89FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B458FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint68_linear_1842_785",
    x1: 953.33,
    y1: 202.826,
    x2: 1018.75,
    y2: 202.826,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E0BBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5199,
    stopColor: "#CA89FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AB4FF7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint69_linear_1842_785",
    x1: 986.041,
    y1: 225.507,
    x2: 1018.75,
    y2: 225.507,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E0B9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5199,
    stopColor: "#CA89FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A94FF2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint70_linear_1842_785",
    x1: 953.33,
    y1: 225.507,
    x2: 986.042,
    y2: 225.507,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E7C9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5199,
    stopColor: "#CA89FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B663F9"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1842_785"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 566,
    height: 485,
    fill: "white",
    transform: "translate(862.334 115.221)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPba);
export default __webpack_public_path__ + "static/media/PBA.9c26c7012b3ac750a9ef4e4205d1d8ee.svg";
export { ForwardRef as ReactComponent };